import apiUrl from '../../../constants'
import { nudgeBus } from '@/utils/nudgeBus'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import jsPDF from 'jspdf';
import Printd from 'printd'
import VueJwtDecode from 'vue-jwt-decode';
import utils from '../../../utils/validateScanner.js'
import IRTException from '../../../utils/IRTException.js';

export default {
  name: 'center-scan-in-trip',
  mixins: [utils,IRTException],
  components: {
    BasicSelect,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      activeTab: 'B2C',
      pageCount: 0,
      pageNo: 0,
      routetype: '',
      sealtype: '',
      bagcondition: "Intact",
      retrivedate: '',
      retrivetime: '',
      bagsealno: '',
      offloadReason: '',
      hubid: '',
      hubName: '',
      vehicletype: '',
      vehiclesealno: '',
      isLoading: false,
      isroutetypeError: '',
      routetypeerrors: '',
      createdby: '',
      offloadreason: '',
      OffloadStatusCode: '',
      offloadReasonArray: [],
      InvalidSealReasonArray: [],
      VehicleListArray: [],
      ConnectionNameData: [],
      BagShortageData: [],
      BagDetails: [],
      connectionLoading: '',
      connectiontype: '',
      connectionfltlist: [],
      connectionfltitem: {
        value: '',
        text: '',
        destinationhubid: ''
      },
      vehicletypelist: [],
      opened: [],
      vehicletypeitem: {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      },
      // for network-local
      networklocalvehiclelist: [],
      networklocalvehicleitem: {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      },
      networklocalvehicle: '',
      networklocalvehicleErr: '',
      vehicleclosekmErr: '',
      networklocalclosekm: '',
      isDestination: false,
      networklocalsealstatus: '',
      networklocalSealStatusErr: '',
      networklocalsealcondition: '',
      networklocalsealconditionErr: '',
      networklocalarrivalsealno: '',
      networklocalarrivalsealnoErr: '',
      networklocaldeparturesealno: '',
      networklocaldeparturesealnoErr: '',
      ScheduleID: '',
      ShortageBagRecord: [],
      disableclosevehiclebtn: true,
      isShoratge: false,
      AllowDepartureSeal: false,
      allowShoratge: true,
      disableFieldforDeparture: false,
      IsSavedDepartureSeal: false,
      reasonlist: [],
      reasonitem: {
        value: '',
        text: ''
      },
      offloadreasonlist: [],
      offloadreasonitem: {
        value: '',
        text: ''
      },
      reason: '',
      connectionname: '',
      bagno: '',
      tripid: '',
      tripsheetno: '',
      invoiceno: '',
      vehicleno: '',
      isConnectionError: 0,
      ConnectionError: '',
      IsVehicleSealNoError: 0,
      VehicleSealNoError: '',
      Isreasonerror: '',
      reasonError: '',
      invalidsealreason: '',
      modaldata: '',
      updatedVehicleSealNo: '',
      disableBtn: 0,
      IsBagConfirm: false,
      OffloadReasontype: false,
      IsNddBagConfirm: false,
      InscanVehicle: false,
      InvalidReason: false,
      modalShow: false,
      updatemodal: false,
      IsOverageShipmentBagTable: true,
      IsBagDetailsTable: false,
      BagData: [],
      vehiclelist: [],
      vehicleitem: {
        value: '',
        text: ''
      },
      localvehicle: '',
      vehicletypeErr: '',
      vehiclesealnoErr: '',
      vehiclesealconditionErr: '',
      currentkm: '',
      IsLocalVehiclesVisible: false,
      ModalStatus: '',
      PDDBagModal: false,
      IsRSC: '',
      vehicletripid: '',
      vehicleNumber: '',
      totalRecords: 0,
      showPendingList: false,
      PendingPaperBagsCount: '',
      parentBagDetails: [],
      childBagDetails: [],
      viewdata: [],
      paperbagno: '',
      PaperBagNoError: '',
      IsPaperWorkBag: false,
      exceptionreason: '',
      ExceptionError: '',
      isexceptional: false,
      missingType: false,
      generatedPaperBagDetails: [],
      IsPaperWorkPending: false,
      paperWorkComplete: false,
      // disablescanInBtn: false,
      disablescanInBtn: true,
      disablePaperWorkBtn: true,
      disableField: false,
      pendingCount: '',
      PendingInscanBagData: [],
      CargoParentMPSDetails: [],
      CargoParentMPSDataModel: false,
      CSMID: '',
      bagstatus: '',
      listtype: 'Ecom',
      IsPendingInscanList: false,
      IsPendingInscanBtn: false,
      InScannedBagsCount: 0,
      PendingBagsCount: 0,
      ShortageBagsCount: 0,
      parentAWB: '',
      ParentAWBError: '',
      IsParentAWB: true,
      //for missing paper bag
      IsMissingPaperBag: false,
      missingType: false,
      missingpaperbag: '',
      MissingPaperBagError: '',
      missingreason: '',
      MissingReasonError: '',
      missroutemsg: '',
      missingpaperbaglist: [],
      missingpaperbagitem: {
        text: ''
      },

      //for prealert data
      IsPrealertData: true,
      PrealertTripData: [],
      PrealertBagData: [],
      PrealertBagShortageList: [],
      totalshipment: 0,
      totalphysicalwt: 0,
      totalvolumetricwt: 0,
      Prealertmodal: false,
      selectedRow: '',
      selectedRowError: '',
      PrealertPrintmodal: false,
      PrintData: '',
      prealertConnection: '',
      prealertVehicle: '',
      prealertInvoiceDate: '',
      prealertInvoiceTime: '',
      IsHeavyShipment: false,
      mpstype:'',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      Loading: false,
      IsUnloadingSheet: false,
      UnloadingSheetModel: false,
      unloadingtripsheetno: '',
      UnloadingTripData: [],
      UnloadingBagData: [],
      isLoadingSheetModal: false,
      IsSheet: false,
      printDate: "",
      printBy: "",
      selectedbags: [],
      TripSheetNoError: '',
      timeoutHandler: 0,
      inputString: '',
      inputString1:'',
      manualInput: false,
      manualInscan:false,
      //for close vehicle
      closeVehicleModal: false,
      IsAllowToCloseVehicle: false,
      CloseVehicleMsg: '',
      userData:[],
      restrictiontype:'inscan',
      Ispendingpaperbag:false,
      Ispendingpaperwork:false,
      IsButtonType:'',
      paperBagCount:false,
      getPendingCount:0,
      getInScannedCount:0,
      getMissingCount:0,
      paperBagData:[],
      isHubRestricted:false,
      isRestrictVehicleSeal:false,
      isConnectionRestricted:true,
      loadingPaperbag:false,
      showcnfrmAllocation: false,
      finalpaperbagno: '',
      CurrentKM: '',
      PaperBagPendingOutscanListModel: false,
      OutScanCount:0,
      CountDetails:[],
      getPendingCountOutscan:-1,
      disablenobagforloadingbtn :true,
      AllowDepartureSealExtra: false,
      pVehicleSealNo:'',
      showOutScanTab:false,
      vehicleSealNoTab:false,
      centerType:'',
      showsidebar:false,
      inscanPendingBagsCount:0,
      inScannedBagsCount:0,
      shortageBagsCount:0,
      inScannedMPSCount:0,
      inscanPendingMPSCount:0,
      shortageMPSCount:0,
      mpsList:[],
      awbPendencyList:[],
      showawblist:false,
      showmpslist:false,
      showsidebutton:false,
      sector:{},
      ConfirmBagShortage: false,
      ConfirmAWBPaperworkShortage: false,
      AWBPaperworkShortageData: null,
			isLoadingSearch:false,
      ShortageBagNo : '',
      scanInRes: {},
      disableDockOutButton: false,
      externalvehiclelist:[],
      externalvehicleitem:{
        value: '',
        text: '',
        vehiclesealno:'',
        vehicleno:'',
        tripreferenceno:''
      },
      externalvehicle:'',
      externalVehicleErr :'',
      externalsealstatus:'',
      externalVehicleSealErr:'',
      externalsealcondition:'',
      externalsealconditionErr:'',
      externalsealno:'',
      externalsealnoErr:'',
      checkexternalsealnoerror:'',
      lsptripreferenceno:'',
      isFlagExRole:true,
      isDisableVehicleSeal:false,
      isNormalUser:false,
      disableloadBagforlsp:true,
      disablePaperWorkInscan:true,
      // lastShipmentInputTime: Date.now(),
      // isScanningForShipment: false,
      // scanTimeoutForShipment: null,
      // scannerInputReceived: false, 

      // scannerInputReceivedupdate: false, 
      // lastShipmentInputTimeupdate: Date.now(),
      // isScanningForShipmentupdate: false,
      // scanTimeoutForShipmentupdate: null,
      allowCompleteInbound : true,
      isCompleteInboundFeatureEnabled : false,
      authorizedShortage : false ,
      intiateAllBagShortage : false,
      pendingEcommShortageDetails : [],
      pendingMPSShortageDetails : [],
      showPendingB2BandB2CList : false,
      authorizedShortage : false ,
      intiateAllBagShortage : false,
      pendingEcommShortageDetails : [],
      pendingMPSShortageDetails : [],
      showPendingB2BandB2CList : false,
      isLinearFlowEnabledbagFlag : false,

          // Dock-In related
      dockId: '',
      dockbarcode:'',
      dockList: [],
      selectedDock: { value: '', text: '' },
      scannedDockBarcode: '',
      isDockIn: false,
      dockIdError: false,
      showChangeDockModal: false,
      newDockId: '',
      newDockBarcode:'',
      newDockSelected: { value: '', text: '' },
      newScannedDockBarcode: '',
      newDockIdError: false,
      changeDockReason: '',
      changeDockReasonError: false,
      selectedReasonError: false,
      isDockMandatory:false,
      isVehicleSealInscanned: false,
      getDockChangeReasonList:[],
      selectedDockChangeReason:{ value: '', text: '' },
      selectedDockChangeReasonError:"",
            // Dock vehicle selection (for local/linehaul routes)
      dockVehiclesList: [],
      selectedDockVehicle: { value: '', text: '' },
      showDockVehicleDropdown: false,
      dockVehicleLoading: false,
      dockLoading: false,
      lastFetchedDockBarcode: '',

    }

  },
  computed: {
    hasScannedDockBarcode() {
      return !!(this.scannedDockBarcode && String(this.scannedDockBarcode).trim().length > 0);
    },
    hasSelectedDockOption() {
      return !!(this.selectedDock && this.selectedDock.value);
    },
    isDockDropdownDisabled() {
      if (this.isDockIn) return true;
      if (!this.hasScannedDockBarcode) return false;
      return !(this.selectedDock && this.selectedDock.value === this.scannedDockBarcode);
    },
    isScanDockBarcodeDisabled() {
      return this.isDockIn || this.hasSelectedDockOption;
    },
    hasNewScannedDockBarcode() {
      return !!(this.newScannedDockBarcode && String(this.newScannedDockBarcode).trim().length > 0);
    },
    hasSelectedNewDockOption() {
      return !!(this.newDockSelected && this.newDockSelected.value);
    },
    isNewDockDropdownDisabled() {
      if (!this.hasNewScannedDockBarcode) return false;
      return !(this.newDockSelected && this.newDockSelected.value === this.newScannedDockBarcode);
    },
    isNewScanDockBarcodeDisabled() {
      return this.hasSelectedNewDockOption;
    },
  },
  watch: {
    isDockMandatory(val) {
      if (val && !this.dockLoading) this.focusScanDockInput();
    },
    dockLoading(val) {
      if (!val && this.isDockMandatory && !this.isDockIn) this.focusScanDockInput();
    },
    showChangeDockModal(val) {
      if (val) this.focusNewDockScanInput();
    },
  },
  /*nxb and xb changes*/
   created: function() {
    this.$validator.extend('checkprefix', {
      getMessage: field => `Vehicle Seal Number Must Start With ${this.vehiclesealdata.sealprefix.join(" or ")}`,
      validate: value => {
        if(value && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
            let result = false
            for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
              if (value.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
                  result = true;
                  break;
              }
            }
            return result;
         }else{
           return true;
         }
      }
   });
 },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    momentPrealert: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData=userdetail
    this.hubid = userdetail[0].HubId[0];
    this.userid = parseInt(userdetail[0].userid, 10); 
    this.createdby = userdetail[0].email
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
    this.getHubName(this.hubid);
    this.hubForManualRestriction();
    // this.getLocalVehicleList();
    // this.getVehicleList();
    //for prealert data
    this.getPrealertTripData();
    // user_tracker.checkUserIP(userdetail[0], "CenterScanInTrip", this.$route.path);
    this.getHubDetailslist(this.hubid);

    // Get List of IRT Exception Type
		this.getExceptionTypes();

    this.getIsDockMandatory();
    // this.getDockList();
  },
  methods: {    
    showsidebarfn(){
      if(!this.CSMID){
        this.$alertify.error("Inscan vehicle seal first.")
        return false;
      }
      if( this.isHubRestricted){
        this.showsidebar=true;
        (this.showsidebar)? this.showsidebutton=false: this.showsidebutton=true;
        this.refreshtripsummary();
      }
    },
    closesidebar(){
      this.showsidebar=false;
      this.showsidebutton=true;
    },
    checkBarcodeForPaperBagOrParentAWB(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString1 += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString1.length <= 3) {
			 		this.manualInscan = true
			 		this.inputString1 = ''
		 		}else{
			 		this.manualInscan = false
			 		this.inputString1 = ''
		 		}
	 		}, 10)
 		},
    openOffLoadMaster() {
      let path = this.$router.resolve("/OffloadShipment/")
      window.open(path.href, '_blank');
    },
    getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
              'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
            this.IsRSC = result.data.ResponseData[0].IsRSC;
            this.centerType = result.data.ResponseData[0].CenterType;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error);
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    getHubDetailslist(hubid) {
      let versionstatus=false;
      this.isCompleteInboundFeatureEnabled = false;
      this.isLinearFlowEnabledbagFlag = false;
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'fetchHubTempInscanRestrict?hubid=' + this.hubid,
          'data': {},
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            versionstatus=result.data.ResponseData[0].isenablecenterscaninnew;
            this.isCompleteInboundFeatureEnabled = result.data.ResponseData[0].ismandatecompleteinboundflag;
            this.isLinearFlowEnabledbagFlag = result.data.ResponseData[0].islinearflowenabledbag;
          if(versionstatus===true)
          {
            let path = this.$router.resolve("/CenterScanInTrip_v1");
            window.open(path.href,"_self");
          }
        }
        }, error => {
          console.error(error)
        })
    },
    getLocalVehicleList() {
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllLocalTrips?hubid=' + self.hubid,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleList = result.data.ResponseData
            this.IsLocalVehiclesVisible = result.data.isLocalVehiclesVisible
            for (var i = 0; i < VehicleList.length; i++) {
              this.vehiclelist.push({
                value: VehicleList[i].tripid,
                text: VehicleList[i].vehicleno,
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.IsLocalVehiclesVisible = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.IsLocalVehiclesVisible = false
          console.error(error)
        })
    },
    selectLocalVehicle(vehicleitem) {
      this.vehicleitem = vehicleitem
      this.localvehicle = this.vehicleitem.text
      this.vehicletripid = this.vehicleitem.value
      this.vehicleNumber = this.vehicleitem.text
    },
    getOffLoadReasons() {
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getOffloadReasons?OffloadReasonType=HubInScanOffload",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.offloadReasonArray = result.data.ResponseData
            for (var i = 0; i < this.offloadReasonArray.length; i++) {
              this.offloadreasonlist.push({
                value: this.offloadReasonArray[i].offloadstatuscode,
                text: this.offloadReasonArray[i].offloadreason
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    selectOffloadReason(offloadreasonitem) {
      this.offloadreasonitem = offloadreasonitem
      this.OffloadStatusCode = this.offloadreasonitem.value
      this.offloadreason = this.offloadreasonitem.text
    },
    getVehicleList(routetype) {
      this.VehicleListArray = []
      this.vehicletypelist = []
      this.networklocalvehiclelist = []
      this.disablePaperWorkInscan=true;
      // var routetype = ''
      // if (this.routetype == 'network-local') {
      //   routetype = 4
      // } else {
      //   routetype = 0
      // }
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getNetworkScanVehicleList?currentHubId=' + self.hubid + '&ConnectionType=' + routetype,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.VehicleListArray = result.data.ResponseData
            /*nxb and xb changes*/
            this.getvehiclesealdata(routetype)
            for (var i = 0; i < this.VehicleListArray.length; i++) {
              this.vehicletypelist.push({
                value: this.VehicleListArray[i].connectionschedulemasterid,
                vehicleno: this.VehicleListArray[i].vehicleno,
                text: this.VehicleListArray[i].vehicleno + '(' + this.VehicleListArray[i].thcno + ')',
                tripid: this.VehicleListArray[i].tripid,
                isdestination: this.VehicleListArray[i].isdestination
              })
              //for network-local
              this.networklocalvehiclelist.push({
                value: this.VehicleListArray[i].connectionschedulemasterid,
                vehicleno: this.VehicleListArray[i].vehicleno,
                text: this.VehicleListArray[i].vehicleno + '(' + this.VehicleListArray[i].thcno + ')',
                tripid: this.VehicleListArray[i].tripid,
                isdestination: this.VehicleListArray[i].isdestination
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    selectVehicleType(vehicletypeitem) {
      this.vehicletypeitem = vehicletypeitem
      this.vehicletype = this.vehicletypeitem.vehicleno
      this.isDestination = this.vehicletypeitem.isdestination
      this.vehicletripid = this.vehicletypeitem.tripid
      this.vehicleNumber = this.vehicletypeitem.vehicleno
      this.ScheduleID = this.vehicletypeitem.connectionschedulemasterid
      this.disablescanInBtn = true
      if (this.vehicletype == '') {
        this.vehicletypeErr = 'The Vehicle Type field is required.'
      } else {
        this.vehicletypeErr = ''
      }
      if (this.vehicletype != '' && this.vehiclesealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }

      if (this.isRestrictVehicleSeal){
        this.getInScannedVehicleSeal(this.vehicletypeitem.value);
      }
      this.disablePaperWorkInscan = true;
    },
    //for network-local
    selectNetworklocalVehicle(networklocalvehicleitem) {
      this.networklocalvehicleitem = networklocalvehicleitem
      this.networklocalvehicle = this.networklocalvehicleitem.vehicleno
      this.isDestination = this.networklocalvehicleitem.isdestination
      this.vehicletripid = this.networklocalvehicleitem.tripid
      this.vehicleNumber = this.networklocalvehicleitem.vehicleno
      this.ScheduleID = this.networklocalvehicleitem.connectionschedulemasterid
      this.disablescanInBtn = true
      if (this.networklocalvehicle == '') {
        this.networklocalvehicleErr = 'The Vehicle List field is required.'
      } else {
        this.networklocalvehicleErr = ''
      }
      if (this.networklocalvehicle != '' && this.networklocalarrivalsealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }
      if (this.isRestrictVehicleSeal){
        this.getInScannedVehicleSeal(this.networklocalvehicleitem.value);
      }
      this.disablePaperWorkInscan = true;
    },

    getInScannedVehicleSeal(connectionschedulemasterid) {
      
      this.isDisableVehicleSeal = false;
      this.networklocalarrivalsealno = '';

      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getInScannedVehicleSeal?HubID=' + this.hubid + '&ConnectionScheduleMasterID=' + connectionschedulemasterid + '&tripId=' + this.vehicletripid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            const preloadedSeal = result.data.ResponseData && result.data.ResponseData.vehiclesealno;
            if (this.routetype == "network-local") this.networklocalarrivalsealno = preloadedSeal;
            else this.vehiclesealno = preloadedSeal;

            this.isDisableVehicleSeal = true;

            if (preloadedSeal && String(preloadedSeal).trim().length > 0) {
              this.isVehicleSealInscanned = true;
            }

            this.$alertify.success(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
          this.$alertify.error('An error occurred while fetching vehicle seal data')
        })
    },

    selectExternalPartnerVehicle(externalvehicleitem) {
  // Assign selected vehicle
  
  this.externalvehicleitem = externalvehicleitem;
  this.externalvehicle = externalvehicleitem.text;
  this.vehicleNumber = externalvehicleitem.vehicleno;
  this.vehicletripid = externalvehicleitem.value;
  this.lsptripreferenceno = externalvehicleitem.tripreferenceno;

  // Set default seal status based on presence of seal number
  if (!externalvehicleitem.lspvehiclesealno) {
    this.externalsealstatus = 'WithoutSeal';
  } else {
    this.externalsealstatus = ''; // User must select
  }

  // Reset seal-related fields
  this.externalsealno = '';
  this.externalsealcondition = '';

  this.externalVehicleSealErr = '';
}
,

 
  // This method is called to check if the route type is "external" and fetch vehicles if true
  getExternalPartnersVehicleList() {
    if (this.routetype === "external") {
      this.isExternalPartner = true;
      // Fetch external partner vehicles from Valmo if the route type is "external"
      this.fetchExternalVehicles();
    }
  },

  // Fetch Valmo vehicles from the backend
  fetchExternalVehicles() {
    const self = this; 
    this.input = {}; 
    
    axios({
      method: 'GET',
      url: `${apiUrl.api_url_hubops}getLspVehicleList?currentHubId=${self.hubid}`,
      headers: {
        'authorization': 'authkey xB84JJ89Hd25',
        'requestfrom': "WEB",
        'token': this.token
      }
    })
    .then(result => {
      // If the request is successful and the result code is 100
      if (result.data.ResultCode === 100) {
        
        const vehicleList = result.data.ResponseData;

        // Populate the vehicle list
        this.externalvehiclelist = vehicleList.map(vehicle => ({
          value: vehicle.lsptripid,
          text: vehicle.lspvehicleno + '(' + vehicle.lsptripid + ')',
          vehiclesealno : vehicle.lspvehiclesealno,
          vehicleno:vehicle.lspvehicleno,
          tripreferenceno:vehicle.lsptripmasterid
        }));
      } else {
        // Handle case when the result code is not 100
        this.isExternalPartner = true;
        this.$alertify.error(result.data.ReturnMessage); // Show error alert
      }
    })
    .catch(error => {
      // Handle any errors that occur during the request
      console.error('Error fetching Valmo vehicles:', error);
      this.$alertify.error('An error occurred while fetching vehicle data.');
    });
  },

  updateLspVehicleClose() {
  this.input = {
    currentHubId: Number(this.hubid),
    lspTripMasterId: this.lsptripreferenceno,
    lspVehicleNo: this.vehicleNumber,
    lastModifiedBy: this.createdby
  };

   axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateLspTripClose',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
  .then(result => {
    if (result.data.ResultCode === 100) {
      this.$alertify.success(result.data.ReturnMessage);
    } else {
      this.$alertify.error(result.data.ReturnMessage || 'Failed to close trip');
    }
  })
  .catch(error => {
    console.error('API error:', error);
    this.$alertify.error('Something went wrong. Please try again.');
  })
  
}
,

    clearCloseKMError() {
      var decimal = /^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]+\.[0-9]*[1-9][0-9]*)$/
      if (this.networklocalclosekm == '') {
        this.vehicleclosekmErr = 'The Close KM field is required.'
      } else if (decimal.test(this.networklocalclosekm) == false) {
        this.vehicleclosekmErr = 'Enter Valid Close KM'
      } else {
        this.vehicleclosekmErr = ''
      }
    },
    clearSealStatusErr() {
      if (this.networklocalsealstatus == ''|| this.externalsealstatus == '') {
        this.networklocalSealStatusErr = 'The Seal Status field is required.'
      } else {
        this.networklocalSealStatusErr = ''
        this.externalsealstatus = ''
        
      }
      this.externalsealconditionErr =''
    },
    checkSealCondition() {
      if (this.sealtype == '') {
        this.vehiclesealconditionErr = 'The Vehicle Seal Condition field is required.'
      } else {
        this.vehiclesealconditionErr = ''
      }
    },
    checknetworklocalsealnoerror() {
      if (this.networklocalarrivalsealno == '') {
        this.networklocalarrivalsealnoErr = 'The Vehicle Seal No field is required.'
      } else {
        this.networklocalarrivalsealnoErr = ''
      }
      if (this.networklocalvehicle != '' && this.networklocalarrivalsealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }
    },
    removeError() {
      if (this.sealtype == '') {
        this.vehiclesealconditionErr = 'The Vehicle Seal Condition field is required.'
        return false;
      } else {
        this.vehiclesealconditionErr = ''
        if (this.vehiclesealno == '') {
          this.vehiclesealnoErr = 'The Vehicle Seal No field is required.'
        } else {
          this.vehiclesealnoErr = ''
        }
      }
      if (this.vehicletype != '' && this.vehiclesealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }
    },

    checkValidationforExternalVehicle() {
      // Reset errors
      this.externalVehicleErr = '';
      this.externalVehicleSealErr = '';
      this.externalsealconditionErr = '';
      this.externalsealnoErr = '';
      
    
      console.log('Validating External Vehicle...');
    
      // Check if Vehicle is selected
      if (this.externalvehicle == '') {
        this.externalVehicleErr = 'The Vehicle field is required.';
        return false;
      }
    
      // Check if Seal Status is selected
      else if (this.externalsealstatus == '') {
        this.externalVehicleSealErr = 'The Seal Status field is required.';
        return false;
      }
    
      // Check if Seal Condition is selected when Seal Status is 'WithSeal'
      else if (this.externalsealstatus === 'WithSeal' && this.externalsealcondition == '') {
        this.externalsealconditionErr = 'Please mark seal condition (Intact/Damaged)';
        return false;
      }
    
      // Check if Seal No is provided when Seal Status is 'WithSeal'
      // else if (this.externalsealstatus === 'WithSeal' && this.externalsealno == '') {
      //   this.externalsealnoErr = 'The Vehicle Seal No field is required.';
      //   return false;
      // }
    
      console.log('External Vehicle validation passed.');
      return true;
    },
    
    // InScanVehicle() {
    InScanVehicle(type) {
      console.log('InScanVehicle clicked, route type:', type);

      if (type === "external") {
        const isValidExternal = this.checkValidationforExternalVehicle();
        if (!isValidExternal) {
          console.log('External vehicle validation failed.');
          return; // Stop further processing if validation fails
        } else {
          console.log('External vehicle validation passed.');
        }
      }
      // for network-local
      var decimal = /^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]+\.[0-9]*[1-9][0-9]*)$/
      if (this.routetype == "network-local" && this.networklocalvehicle == '') {
        this.networklocalvehicleErr = 'The Vehicle field is required.'
        return false;
      } else if (this.isDestination == true && this.networklocalclosekm == '') {
        this.vehicleclosekmErr = 'The Close KM field is required.'
        return false;
      } else if (this.isDestination == true && decimal.test(this.networklocalclosekm) == false) {
        this.vehicleclosekmErr = 'Enter Valid Close KM'
        return false;
      } else if (this.routetype == "network-local" && this.networklocalsealstatus == '' && this.isFlagExRole) {
        this.networklocalSealStatusErr = 'The Seal Status field is required.'
        return false;
      }
      // else if (this.routetype == "network-local" && this.networklocalsealcondition == '') {
      //   this.networklocalsealconditionErr = 'The Seal Condition field is required.'
      //   return false;
      // }
      else if (this.routetype == "network-local" && this.networklocalarrivalsealno == '') {
        this.networklocalarrivalsealnoErr = 'The Vehicle Seal No field is required.'
        return false;
      }
      else {
        this.networklocalvehicleErr = ''
        this.networklocalSealStatusErr = ''
        //this.networklocalsealconditionErr = ''
        this.networklocalarrivalsealnoErr = ''
        this.vehicleclosekmErr = ''
      }
      if (this.routetype == "network" && this.vehicletype == '' && this.isFlagExRole) {
        this.vehicletypeErr = 'The Vehicle Type field is required.'
        return false;
      } else if (this.routetype == "network" && this.sealtype == '' && this.isFlagExRole) {
        this.vehiclesealconditionErr = 'The Vehicle Seal Condition field is required.'
        return false;
      } else if (this.routetype == "network" && this.vehiclesealno == '') {
        this.vehiclesealnoErr = 'The Vehicle Seal No field is required.'
        return false;
      } else {
        this.vehicletypeErr = ''
        this.vehiclesealconditionErr = ''
        this.vehiclesealnoErr = ''
      }
      this.disablescanInBtn = true
      // for network-local
      if (type == 'networklocal') {
        this.input = ({
          "HubID": this.hubid,
          "VehicleSealNo": this.networklocalarrivalsealno,
          "ConnectionScheduleMasterID": this.networklocalvehicleitem.value,
          "Reason": this.InvalidReason == true ? this.invalidsealreason : '',
          "LastModifiedBy": this.createdby,
          "VehicleSealCondition": this.networklocalsealcondition,
          "vehicleSealStatus": this.networklocalsealstatus,
          "isHubRestricted":this.isHubRestricted,
          "isNormalUser":this.isNormalUser
        })
      }else if(type == 'external'){
        this.input =({
          "HubID": this.hubid,
          "VehicleSealNo": this.externalsealno,
          "ConnectionScheduleMasterID": 0,
          "Reason":  '',
          "LastModifiedBy": this.createdby,
          "VehicleSealCondition": this.externalsealcondition,
          "isHubRestricted":this.isHubRestricted,
          "tripId":this.vehicletripid,
          "vehicleSealStatus": this.externalsealstatus,
          "isLsp":true
      })

      }else {
        this.input = ({
          "HubID": this.hubid,
          "VehicleSealNo": this.vehiclesealno,
          "ConnectionScheduleMasterID": this.vehicletypeitem.value,
          "Reason": this.InvalidReason == true ? this.invalidsealreason : '',
          "LastModifiedBy": this.createdby,
          "VehicleSealCondition": this.networklocalsealcondition,
          "isHubRestricted":this.isHubRestricted,
          "isNormalUser":this.isNormalUser,
          "vehicleSealStatus": this.sealtype,
        })
        
      }
      if (type == 'networklocal' && this.networklocalarrivalsealno != "") {
        this.input.VehicleSealNo = this.networklocalarrivalsealno
      }
      if (this.isDestination == true) {
        this.input.CurrentKM = this.networklocalclosekm
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'inscanVehicle',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.disablePaperWorkInscan = false;
            if (this.routetype == "network" && this.vehicletypeitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
            if (this.routetype == "network-local" && this.networklocalvehicleitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
            if (this.AllowDepartureSeal == true) {
              this.disableFieldforDeparture = true
            }

            if(this.routetype == "external"){
              
              this.disablescanInBtn = false;
              this.IsPendingInscanBtn = true
              this.getPendingInscanBagCount();
              this.$alertify.success(result.data.ReturnMessage);
              this.allowShoratge = false;
              this.allowCompleteInbound = false;
              this.disableloadBagforlsp = false;
              
            }else{
            this.IsPendingInscanBtn = true
            this.allowShoratge = false
            this.allowCompleteInbound = false;
            this.disablescanInBtn = false
            this.isVehicleSealInscanned = true
            this.getPendingInscanBagCount();
            this.invalidTokenModal = false
            this.tripid = result.data.ResponseData.tripid
            this.tripsheetno = result.data.ResponseData.thcno
            this.invoiceno = result.data.ResponseData.invoiceno
            this.vehicleno = result.data.ResponseData.vehicleno
            this.CSMID = result.data.ResponseData.connectionschedulemasterid
            this.paperBagCount=true
            // this.disableBtn = 1
            
            this.getPaperBagCount();
            this.getInScanPendingCount();
  
            this.getPaperBagCountOutscan();
            if (this.isDockMandatory) {
              this.checkDockIn(this.vehicleno);
            }
            if (this.isHubRestricted) {
              this.showsidebar=true;
              (this.showsidebar)? this.showsidebutton=false: this.showsidebutton=true;
            }
            this.$alertify.success(result.data.ReturnMessage)
          }
            
          } else if (result.data.ResultCode == 109) {
            this.AllowDepartureSeal = false
            //this.disableBtn = 0
            this.invalidTokenModal = false
            this.InvalidReason = true
            this.allowShoratge = true
            this.allowCompleteInbound = true;
            this.getInvalidSealReason();
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 102) {

            if(this.routetype == "external"){
              this.disablescanInBtn = false;
              this.IsPendingInscanBtn = true
              this.getPendingInscanBagCount();
              this.allowShoratge = false
              this.allowCompleteInbound = false;
              this.disableloadBagforlsp = false;
            }else{
              this.IsPendingInscanBtn = true
              this.invalidTokenModal = false
              this.tripid = result.data.ResponseData.tripid
              this.tripsheetno = result.data.ResponseData.thcno
              this.invoiceno = result.data.ResponseData.invoiceno
              this.vehicleno = result.data.ResponseData.vehicleno
              this.CSMID = result.data.ResponseData.connectionschedulemasterid
              this.allowShoratge = false
              this.allowCompleteInbound = false;
              this.disablescanInBtn = false
              this.isVehicleSealInscanned = true
              this.paperBagCount=true
              this.getPendingInscanBagCount();
              this.getPaperBagCount();
              this.getInScanPendingCount();
              this.getPaperBagCountOutscan();
              this.disablePaperWorkInscan = false;
              if (this.isDockMandatory) {
                this.checkDockIn(this.vehicleno);
              }
            }
            if (this.routetype == "network" && this.vehicletypeitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
            if (this.routetype == "network-local" && this.networklocalvehicleitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
            if (this.AllowDepartureSeal == true) {
              this.disableFieldforDeparture = true
            }
            
            if (this.isHubRestricted) {
              this.showsidebar=true;
              (this.showsidebar)? this.showsidebutton=false: this.showsidebutton=true;
            }
            this.$alertify.error(result.data.ReturnMessage)
            //this.disableBtn = 1
          } else if (result.data.ResultCode == 401) {
            this.AllowDepartureSeal = false

            this.invalidTokenModal = true
            this.allowShoratge = true
            this.allowCompleteInbound = true;
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.AllowDepartureSeal = false
            this.invalidTokenModal = false
            this.allowShoratge = true
            this.allowCompleteInbound = true;
            //this.disableBtn = 0
            this.InvalidReason = false
            this.IsPendingInscanBtn = false
            this.paperBagCount=false
            this.$alertify.error(result.data.ReturnMessage)
          }
          //for paper work
          this.IsPaperWorkPending = result.data.IsPaperWorkPending
          this.isEcom=result.data.isEcom
          if (this.IsPaperWorkPending == true) {
            this.disablescanInBtn = true
            this.disablePaperWorkBtn = false
            this.disableField = true
            this.bagcondition = "Intact"
            this.bagsealno = ''
            this.manualInput = false
            this.offloadreason = ''
            this.offloadreasonitem = {
              value: '',
              text: ''
            }
          } else {
            this.disablePaperWorkBtn = true
            this.disableField = false
          }
        }, error => {
          console.error(error)
        })
    },
    getInvalidSealReason() {
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getInvalidSealReasons",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.InvalidSealReasonArray = result.data.ResponseData
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    openUpdateModal() {
      this.updatemodal = true
    },
    closeUpdateModal() {
      this.updatemodal = false
      this.updatedVehicleSealNo = ''
    },
    clearError() {
      if (this.updatedVehicleSealNo == '') {
        this.IsVehicleSealNoError = 1,
          this.VehicleSealNoError = 'The Vehicle Seal No field is required.'
      } else {
        this.IsVehicleSealNoError = 0,
          this.VehicleSealNoError = ''
      }
    },
    clearDepartureSealNoError() {
      if (this.networklocaldeparturesealno == '') {
        this.networklocaldeparturesealnoErr = 'The Vehicle Departure Seal No field is required.'
      } else {
        this.networklocaldeparturesealnoErr = ''
      }
    },
    UpdateVehicle(type) {
      if (type == "networklocal" && this.networklocaldeparturesealno == '') {
        this.networklocaldeparturesealnoErr = 'The Vehicle Departure Seal No field is required.'
        return false;
      } else {
        this.networklocaldeparturesealnoErr = ''
      }


      if (type != "networklocal" && this.updatedVehicleSealNo == '') {
        this.IsVehicleSealNoError = 1,
          this.VehicleSealNoError = 'The Vehicle Seal No field is required.'
        return false;
      } else {
        this.IsVehicleSealNoError = 0,
          this.VehicleSealNoError = ''
      }
      if (this.routetype == "network-local") {
        this.input = ({
          "ConnectionScheduleMasterID": this.networklocalvehicleitem.value,
          "TripID": Number(this.tripid),
          "CurrentHubId": this.hubid,
          "VehicleSealNo": this.networklocaldeparturesealno,
          "LastModifiedBy": this.createdby
        })
      } else {
        this.input = ({
          "ConnectionScheduleMasterID": this.vehicletypeitem.value,
          "TripID": Number(this.tripid),
          "CurrentHubId": this.hubid,
          "VehicleSealNo": this.updatedVehicleSealNo,
          "LastModifiedBy": this.createdby
        })
      }
      if (type == 'networklocal') {
        this.input.VehicleSealNo = this.networklocaldeparturesealno
      } else {
        this.input.VehicleSealNo = this.updatedVehicleSealNo
      }

      this.disablescanInBtn = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'updateVehicleSeal',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.disableBtn = 1
            /*nxb and xb changes*/
            let connType = (this.routetype == "network-local") ? 4 : (this.routetype =='network') ? 0 : null
            this.getvehiclesealdata(connType)
            if (type != 'networklocal') {
              this.networklocaldeparturesealno = this.updatedVehicleSealNo
            }
            this.invalidTokenModal = false
            this.updatemodal = false
            //this.networklocaldeparturesealno = ''
            this.updatedVehicleSealNo = ''
            this.$validator.reset();
            this.IsSavedDepartureSeal = true
            this.$alertify.success(result.data.ReturnMessage)
            if (type == "networklocal") {
              this.disableFieldforDeparture = false
              this.IsSavedDepartureSeal = true
            }
            this.disablescanInBtn = false;
          } else if (result.data.ResultCode == 401) {
            this.disableBtn = 0
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
            this.IsSavedDepartureSeal = false
          } else {
            this.invalidTokenModal = false
            if (type == "networklocal") {
              this.disableBtn = 0
              this.IsSavedDepartureSeal = false
              this.networklocaldeparturesealno = '';
            } else {
              this.disableBtn = 1
              this.IsSavedDepartureSeal = true
              this.updatedVehicleSealNo = '';
            }
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    /*nxb and xb changes*/
    getvehiclesealdata(routetype){
      this.vehiclesealdata = {}
      this.isFlagExRole = true;
      this.isRestrictVehicleSeal = false;
       axios({
           method: 'GET',
           url: apiUrl.api_url_hubops + 'getVehicleSealConfiguration?hubid=' + this.hubid,
           data: this.input,
           headers: {
             'authorization': 'authkey xB84JJ89Hd25'
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
            this.vehiclesealdata  =  result.data.ResponseData.find(x => x.connectionType == routetype);
            this.isHubRestricted=result.data.ManualRestriction.restrictpaperbagcheck;
            this.isRestrictVehicleSeal=result.data.ManualRestriction.isrestrictvehiclesealmanualinscan;

            let accessToken = window.localStorage.getItem('access_token');
              let roles = VueJwtDecode.decode(accessToken);
              roles = roles.resource_access;
              roles = roles["hubops-service"];
              roles = roles.roles;
              roles = roles.map(item => item.toLowerCase());

            if(this.isRestrictVehicleSeal) {              
              let excRoles  =  result.data.config.cs_web_roles;
              excRoles.map(item => item.toLowerCase());
              this.isFlagExRole = excRoles.some(value => roles.includes(value));
              this.isNormalUser = !this.isFlagExRole;

              let ciwebRoles  =  result.data.config.ci_web_roles;
              ciwebRoles.map(item => item.toLowerCase());
              this.authorizedShortage = excRoles.some(value => roles.includes(value));
            }
             let ciwebRoles = result.data.config.ci_web_roles ? result.data.config.ci_web_roles : [];
              const ciwebRolesLower = ciwebRoles.map(item =>item ? item.toLowerCase() : "");
              this.authorizedShortage = ciwebRolesLower.some(value => roles.includes(value));
           }
         })
      },
    ScanIn() {
      this.sealtype = this.sealtype ? this.sealtype : 'WithSeal';
      
      if (this.routetype == '' || this.sealtype == '' || this.bagcondition == '' || this.bagsealno == '') {
        this.manualInput = false
        return false
      } else {
        this.Loading = true
        this.isLoading = true;
        this.scanInRes = {};
        this.input = ({
          "BagReceiveCondition": this.bagcondition,
          "Routetype": this.routetype,
          "SealType": this.sealtype,
          "SealNo": this.bagsealno.trim(),
          "currentHubId": this.hubid,
          "currentHubName": this.hubName,
          "bagNumber": this.bagsealno,
          "LastModifiedBy": this.createdby,
          "IsRSC": this.IsRSC,
          "statusMarkedFrom": "web",
          "IsNddBagConfirm": this.IsBagConfirm == true ? this.IsNddBagConfirm : false,
          "TripID": this.vehicletripid,
          "VehicleNo": this.vehicleNumber,
          "CurrentKM": this.currentkm,
          "ProcessNonPDDBag": false,
          "isManualEntry": this.manualInput,
          'isConnectionRestricted':this.isConnectionRestricted,
          'isHubRestricted' :this.isHubRestricted,
          "dock_barcode": this.dockbarcode,
        })
        
        if (this.userid) {
          this.input.userId = this.userid;
        }

        //Adding the 'isLspFlag' property if routetype is 'external'
    if (this.routetype == 'external') {
      this.input.TripID = this.lsptripreferenceno
      this.input.isLsp = true;
    }
        if (this.OffloadReasontype == true) {
          this.input.OffloadStatusCode = this.OffloadStatusCode,
            this.input.OffloadReason = this.offloadreason
        }
        // if (this.routetype == 'network-local' && this.isDestination == true) {
        //   this.input.CurrentKM = this.networklocalclosekm
        // }
        if (this.isDestination == true) {
          this.input.CurrentKM = this.networklocalclosekm
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'scanIn',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.Loading = false
            this.isLoading = false;
            this.OffloadReasontype = false
            this.scanInRes = result.data;
            this.disableDockOutButton = false;
            this.showHideCodeIconInput();
            if (result.data.ResultCode == 100) {
              this.IsHeavyShipment = result.data.isHeavyShipment
              this.mpstype = result.data.mpstype
              this.invalidTokenModal = false
              if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
              this.$toast.success(result.data.ReturnMessage, {
                timeout: 10000,
                position: 'bottom-right',
              });
                
          // Check for air shipment mode
              if (result.data.mot === 'AIR') {
                this.addBlur();
                this.$toast.info('Mode: AIR', {
                timeout: 10000,
                position: 'top-right',
                className: 'blue-toast', // Custom class for styling
                onClose: this.removeBlur,  // Remove blur when the toast closes
              });
          }
        
               // Hide after 10 seconds
              //
              //this.$alertify.success(result.data.ReturnMessage)
              this.bagsealno = ''
              this.manualInput = false
              this.$validator.reset()
              if (this.CSMID != '') {
                this.getPendingInscanBagCount();
                this.getPaperBagCount();
                this.getInScanPendingCount();
              }

              if(Object.keys(result.data.lossCategorization).length !=0){
							this.colorCode = result.data.lossCategorization.colorCode;
							this.colorIcon = result.data.lossCategorization.icon;
						}
              //this.resetForm()
            } else if (result.data.ResultCode == 107) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.$alertify.error("Please select Offload Reason")
              this.OffloadReasontype = true
              this.getOffLoadReasons()
              this.showHideCodeIconInput();
            }   else if (result.data.ResultCode == 120) {
              this.IsHeavyShipment = result.data.isHeavyShipment
              this.mpstype = result.data.mpstype
              this.invalidTokenModal = false
              this.$toast.success(result.data.ReturnMessage, {
                timeout: 10000,
                position: 'bottom-right',
              });
              
                
            } else if (result.data.ResultCode == 108) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.IsBagConfirm = true
              this.IsNddBagConfirm = true
            } else if (result.data.ResultCode == 105) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.PDDBagModal = true
              this.ModalStatus = result.data.ReturnMessage
            } else if (result.data.ResultCode == 109) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.disablePaperWorkBtn = false
              this.$alertify.error(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 401) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
              
            }

            if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }

            // IRT Exception Error & Tracking No
            if(result.data.Trackingno) this.openIRTExceptionModal(this.bagsealno, result.data.ReturnMessage, result.data.Trackingno);
            
            user_tracker.checkUserIP(this.userData[0], "CenterScanInTrip_BagInScan", this.$route.path,this.input);
          }, error => {
            this.Loading = false
            console.error(error)
          })
      }
    },

    addBlur() {
      document.body.classList.add('blurred');
    },
    removeBlur() {
      document.body.classList.remove('blurred');
    },
  
    processPDDBag() {
      this.Loading = true
      this.isLoading = true;
      this.scanInRes = {};
      this.input = ({
        "BagReceiveCondition": this.bagcondition,
        "Routetype": this.routetype,
        "SealType": this.sealtype,
        "SealNo": this.bagsealno.trim(),
        "currentHubId": this.hubid,
        "currentHubName": this.hubName,
        "bagNumber": this.bagsealno,
        "LastModifiedBy": this.createdby,
        "IsRSC": this.IsRSC,
        "statusMarkedFrom": "web",
        "IsNddBagConfirm": this.IsBagConfirm == true ? this.IsNddBagConfirm : false,
        "TripID": this.vehicletripid,
        "VehicleNo": this.vehicleNumber,
        "CurrentKM": this.currentkm,
        "ProcessNonPDDBag": true,
        "isManualEntry": this.manualInput,
        "dock_barcode": this.dockbarcode,
      })
      if (this.OffloadReasontype == true) {
        this.input.OffloadStatusCode = this.OffloadStatusCode,
          this.input.OffloadReason = this.offloadreason
      }
      // if (this.routetype == 'network-local' && this.isDestination == true) {
      //   this.input.CurrentKM = this.networklocalclosekm
      // }
      if (this.isDestination == true) {
        this.input.CurrentKM = this.networklocalclosekm
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'scanIn',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.Loading = false
          this.isLoading = false;
          this.OffloadReasontype = false
          this.scanInRes = result.data;
          this.disableDockOutButton = false;
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = result.data.isHeavyShipment
            this.mpstype = result.data.mpstype
            this.$alertify.success(result.data.ReturnMessage)
            if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
            this.bagsealno = ''
            this.manualInput = false
            this.$validator.reset()
            //this.resetForm()
          } else if (result.data.ResultCode == 107) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.$alertify.error("Please select Offload Reason")
            this.OffloadReasontype = true
            this.getOffLoadReasons()
          } else if (result.data.ResultCode == 108) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.IsBagConfirm = true
            this.IsNddBagConfirm = true
          } else if (result.data.ResultCode == 105) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.PDDBagModal = true
            this.ModalStatus = result.data.ReturnMessage
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.Loading = false
          console.error(error)
        })
    },
    closePDDBagModal() {
      this.PDDBagModal = false
    },
    clearRoutetypeError() {
      if (this.routetype == "linehaul") {
        this.sealtype = 'WithoutSeal'
      } else {
        this.sealtype = ''
      }
      if (this.routetype == '') {
        this.isroutetypeError = '1',
          this.routetypeerrors = 'The Route Type field is required.'
      } else {
        this.isroutetypeError = '',
          this.routetypeerrors = ''
      }
      this.disablescanInBtn= false
      if (this.routetype == "network" || this.routetype == "network-local") {
        this.disablescanInBtn = true
      }
      if(this.routetype == "external"){
        this.disableloadBagforlsp = true;
      }
      this.bagcondition = "Intact"
      this.bagsealno = ''
      this.manualInput = false
      this.offloadReason = ''
      this.isroutetypeError = ''
      this.routetypeerrors = ''
      this.vehicletype = ''
      this.vehiclesealno = ''
      this.invalidsealreason = ''
      this.vehicletypeErr = ''
      this.vehiclesealnoErr = ''
      this.vehiclesealconditionErr = ''
      this.vehiclelist = []
      this.vehicletypelist = []
      // this.vehicletypelist = []
      this.vehicletypeitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      //for network-local
      this.allowShoratge = true
      this.allowCompleteInbound = true;
      this.disableFieldforDeparture = false
      this.networklocalvehiclelist = []
      // this.vehicletypelist = []
      this.networklocalvehicleitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.networklocalvehicleErr = ''
      this.vehicleclosekmErr = ''
      this.isDestination = false
      this.networklocalsealstatus = ''
      this.networklocalSealStatusErr = ''
      this.networklocalsealcondition = ''
      this.networklocalsealconditionErr = ''
      this.networklocalarrivalsealno = ''
      this.networklocalarrivalsealnoErr = ''
      this.networklocaldeparturesealno = ''
      this.networklocaldeparturesealnoErr = ''
      this.vehicleitem = {
        value: '',
        text: ''
      }
      /*nxb and xb changes*/
      this.vehiclesealdata={
        connectiontype:'',
        connectionname:'',
        sealprefix:[]
      }
      this.localvehicle = ''
      this.currentkm = ''
      this.OffloadReasontype = false
      this.IsNddBagConfirm = false
      this.InscanVehicle = false
      this.InvalidReason = false
      this.IsLocalVehiclesVisible = false
      this.disableBtn = 0
      this.disableclosevehiclebtn = true
      this.AllowDepartureSeal = false
      this.updatedVehicleSealNo = ''
      this.IsSavedDepartureSeal = false
      this.tripid = ''
      this.tripsheetno = ''
      this.invoiceno = ''
      this.vehicleno = ''
      this.CSMID = ''
      this.vehicletripid = ''
      this.vehicleNumber = ''
      this.ScheduleID = ''
      this.IsHeavyShipment = false
      this.mpstype = ''
      this.externalVehicleErr=''
      this.externalvehicleitem =''
      this.externalvehicle=''
      this.externalsealstatus=''
      this.externalsealcondition =''
      this.externalsealno =''
      this.lsptripreferenceno =''
      this.isDisableVehicleSeal = false
      // this.getVehicleList()
      // Reset dock fields
      this.resetDock();
      this.isDockIn = false;
      this.isVehicleSealInscanned = false;

      this.$validator.reset();
    },
    resetForm() {
      this.routetype = ''
      this.sealtype = ''
      this.bagcondition = "Intact"
      this.bagsealno = ''
      this.manualInput = false
      this.offloadReason = ''
      this.isroutetypeError = ''
      this.routetypeerrors = ''
      this.vehicletype = ''
      this.vehiclesealno = ''
      this.invalidsealreason = ''
      this.vehicletypeitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.offloadreasonitem = {
        value: '',
        text: ''
      }
      this.vehicleitem = {
        value: '',
        text: ''
      }
      /*nxb and xb changes*/
      this.vehiclesealdata={
        connectiontype:'',
        connectionname:'',
        sealprefix:[]
      }
      this.localvehicle = ''
      this.vehicletypeErr = ''
      this.vehiclesealnoErr = ''
      this.vehiclesealconditionErr = ''
      this.disableBtn = 0
      this.currentkm = ''
      this.vehicleNumber = ''
      this.OffloadReasontype = false
      this.IsNddBagConfirm = false
      this.InscanVehicle = false
      this.InvalidReason = false
      if(this.routetype == "external"){
        this.disableloadBagforlsp = true
      }
      //for paper work
      this.IsPaperWorkPending = false
      this.paperWorkComplete = false
      this.disablescanInBtn = false
      if (this.routetype == "network" || this.routetype == "network-local") {
        this.disablescanInBtn = true
      }
      this.disablePaperWorkBtn = true
      this.disableField = false
      this.IsPendingInscanBtn = false
      this.IsPendingInscanList = false
      this.IsLocalVehiclesVisible = false
      // for network-local
      this.allowShoratge = true
      this.allowCompleteInbound = true
      this.disableFieldforDeparture = false
      this.networklocalvehicleitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.networklocalvehicle = ''
      this.networklocalvehicleErr = ''
      this.vehicleclosekmErr = ''
      this.networklocalclosekm = ''
      this.isDestination = false,
        this.networklocalsealstatus = ''
      this.networklocalSealStatusErr = ''
      this.networklocalsealcondition = ''
      this.networklocalsealconditionErr = ''
      this.networklocalarrivalsealno = ''
      this.networklocalarrivalsealnoErr = ''
      this.networklocaldeparturesealno = ''
      this.updatedVehicleSealNo = ''
      this.IsSavedDepartureSeal = false
      this.networklocaldeparturesealnoErr = ''
      this.ShortageBagRecord = []
      this.PendingInscanBagData = []
      this.disableclosevehiclebtn = true
      this.AllowDepartureSeal = false
      this.isShoratge = false
      this.listtype = 'Ecom'
      this.missingpaperbag = ''
      this.missingpaperbagitem = {
        text: ''
      }
      this.MissingPaperBagError = ''
      this.missingreason = ''
      this.MissingReasonError = ''
      this.IsMissingPaperBag = false
      this.missingType = false
      this.missroutemsg = ''
      this.IsHeavyShipment = false
      this.mpstype = ''
      this.tripid = ''
      this.tripsheetno = ''
      this.invoiceno = ''
      this.vehicleno = ''
      this.CSMID = ''
      this.vehicletripid = ''
      this.vehicleNumber = ''
      this.ScheduleID = ''
      this.CloseVehicleMsg = ''
      this.closeVehicleModal = false
      this.IsAllowToCloseVehicle = false
      this.Ispendingpaperbag=false
      this.Ispendingpaperwork=false
      this.IsButtonType=''
      this.paperBagCount=false,
      this.getPendingCount=0,
      this.getInScannedCount=0,
      this.getMissingCount=0,
      this.paperBagData=[],
      this.isHubRestricted=false
      this.loadingPaperbag=false
      this.OutScanCount = 0;
      this.showsidebar=false,
      this.showsidebutton=false,
      this.inscanPendingBagsCount=0,
      this.inScannedBagsCount=0,
      this.shortageBagsCount=0,
      this.inScannedMPSCount=0,
      this.inscanPendingMPSCount=0,
      this.shortageMPSCount=0,
      this.mpsList=[],
      this.awbPendencyList=[],
      this.showawblist=false,
      this.showmpslist=false
      this.isDisableVehicleSeal = false,
      // Reset dock fields on route type switch
      this.resetDock();
      this.isDockIn = false;
      this.isVehicleSealInscanned = false;

      this.$validator.reset();
      this.showHideCodeIconInput();

    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (this.routetype == '') {
          this.isroutetypeError = '1',
            this.routetypeerrors = 'The Route Type field is required.'
        } else {
          this.isroutetypeError = '',
            this.routetypeerrors = ''
        }
        this.vehicletypeErr = ''
        this.vehiclesealnoErr = ''
        this.vehiclesealconditionErr = ''
        this.networklocalvehicleErr = ''
        this.vehicleclosekmErr = ''
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    //For Mark Bag Shortage
    //get connection name
    searchConnection(connectionfltitem) {
      this.connectionfltitem = connectionfltitem
      this.connectionname = this.connectionfltitem.text
    },
    //to get connection name list
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      this.ConnectionNameData = []
      this.connectionfltlist = []
      this.connectionname = ''
      this.connectionfltitem = {
        value: '',
        text: '',
        destinationhubid: ''
      }
      this.$validator.reset()
      this.input = ({
        "destinationHubID": this.hubid,
        "isLocalConnections": this.connectiontype
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getConnectionsList',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.connectionLoading = ''
          this.ConnectionNameData = result.data.ResponseData
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.isConnectionError = 0;
            this.ConnectionError = ''
            for (i = 0; i < this.ConnectionNameData.length; i++) {
              this.connectionfltlist.push({
                value: this.ConnectionNameData[i].ConnectionID,
                text: this.ConnectionNameData[i].ConnectionName,
                destinationhubid: this.ConnectionNameData[i].destinationHubID
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isConnectionError = 1;
            this.ConnectionError = 'No Connection Found'
          }
        }, error => {
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },
    //called on search button
    getBagShortageData() {
      this.IsBagDetailsTable = false
      this.IsOverageShipmentBagTable = true
      this.ConnectionNameData = []
      this.BagShortageData = []
      this.BagDetails = []
      this.opened = []
      if (this.connectionfltitem.destinationhubid != "" && this.connectionfltitem.value != "") {
        this.input = ({
          "destinationHubID": Number(this.connectionfltitem.destinationhubid),
          "connectionID": this.connectionfltitem.value
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagCountByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagShortageData = result.data.ResponseData
              if (this.bagno != '') {
                this.getBagDetails(this.BagShortageData[0], 0)
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    //called on No of Bags
    getBagDetails(data, ind) {
      this.BagDetails = []
      const index = this.opened.indexOf(ind);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(ind)
        this.input = ({
          "destinationHubID": Number(data.HubID),
          "connectionID": Number(data.connectionid)
        })
        if (this.bagno != '') {
          this.input.bagNumber = this.bagno
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagDetailsByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagDetails = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              //this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeBagDetailsList() {
      this.opened = [];
    },
    //called on No of Bags
    showBagData() {
      if (this.bagno != '') {
        this.IsBagDetailsTable = true
        this.IsOverageShipmentBagTable = false
        this.BagData = []
        this.input = ({
          "destinationHubID": Number(this.connectionfltitem.destinationhubid),
          "connectionID": Number(this.connectionfltitem.value),
          "bagNumber": this.bagno
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagDetailsByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagData = result.data.ResponseData
              if(Object.keys(result.data.lossCategorization).length !=0){
							this.colorCode = result.data.lossCategorization.colorCode;
							this.colorIcon = result.data.lossCategorization.icon;
						}
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.showHideCodeIconInput();
              this.$alertify.error(result.data.ReturnMessage)
              
            } else {
              this.invalidTokenModal = false
              this.showHideCodeIconInput();
              this.$alertify.error(result.data.ReturnMessage)
              
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.IsBagDetailsTable = false
        this.IsOverageShipmentBagTable = true
        this.showHideCodeIconInput();
      }
    },
    openModal(bdata) {
      this.modaldata = bdata
      this.modalShow = true
      this.getBagShortageReason()
    },
    closeModal() {
      this.modalShow = false
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.Isreasonerror = ''
      this.reasonError = ''
    },
    //get selected shortage reason
    selectReason(reasonitem) {
      this.reasonitem = reasonitem
      this.reason = this.reasonitem.text
      if (this.reasonitem.text == '') {
        this.Isreasonerror = '1',
          this.reasonError = 'The Shortage Reason field is required.'
      } else {
        this.Isreasonerror = '',
          this.reasonError = ''
      }
    },
    ConfirmbBagShortageMark(data) {
			this.ConfirmBagShortage = true;
      this.ShortageBagNo = data.bagno;
		},
		CloseConfirmation() {
			this.ConfirmBagShortage = false;
		},
    markBagShortage(type) {
      // Validate if the Prealert modal is open and a row is selected
      if (this.Prealertmodal === true && this.selectedRow === '') {
        this.selectedRowError = 'Select Bag Number';
        return false;
      } else {
        this.selectedRowError = '';
      }
    
      this.isLoadingSearch = true;
    
      // Set up the input data based on the type (Shortage or other)
      if (type === 'Shortage') {
        this.input = {
          currentHubId: this.hubid,
          currentHubName: this.hubName,
          parentBagNo: this.ShortageBagNo,
          lastModifiedBy: this.createdby,
          reason: this.reasonitem.text,
          centerType: this.centerType,
          userId:this.userid,
          TripID:Number(this.vehicletripid),
          statusMarkedFrom: "WEB"
        };
    
        // For external route type, clear centerType field
        if (this.routetype === 'external') {
          delete this.input.centerType;
          delete this.input.userId;
          delete this.input.TripID;
          delete this.input.statusMarkedFrom;
        }
      } else {
        this.input = {
          currentHubId: this.hubid,
          currentHubName: this.hubName,
          parentBagNo: this.modaldata.bagnumber,
          lastModifiedBy: this.createdby,
          reason: this.reasonitem.text,
          centerType: this.centerType,
          userId:this.userid,
          TripID:Number(this.vehicletripid),
          statusMarkedFrom: "WEB"
        };
      }
    
      // Handle the case when Prealert modal is open and a bag number is selected
      if (this.Prealertmodal === true && this.selectedRow.bagno !== '') {
        this.input.parentBagNo = this.selectedRow.bagno;
      }
    
     
      let url;
      let method = 'POST'; 
    
      if (this.routetype === 'external') {
        
        url = `${apiUrl.api_url_hubops}lspMarkBagShortage`;
        method = 'PUT'; // External API uses PUT
      } else {
        // Internal API for marking bag shortage
        url = `${apiUrl.api_url_hubops}markBagShortage`;
      }
    
     
      axios({
        method: method,
        url: url,
        data: this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token,
        },
      })
        .then((result) => {
          if (result.data.ResultCode === 100) {
            // Success case: Show success message and reset the modal
            this.invalidTokenModal = false;
            this.$alertify.success(result.data.ReturnMessage);
            this.modalShow = false;
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
            this.resetShortageForm();
            if(!this.isCompleteInboundFeatureEnabled){
              this.getPendingInscanBagList();
            }else{
            this.getPendingB2BandB2CList();            
          }
            this.getPendingInscanBagCount();
          } else if (result.data.ResultCode === 401) {
          
            this.invalidTokenModal = true;
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            this.invalidtokenmsg = result.data.ReturnMessage;
            this.$alertify.error(result.data.ReturnMessage);
          } else {
            // Any other error case
            this.invalidTokenModal = false;
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            this.$alertify.error(result.data.ReturnMessage);
          }
        })
        .catch((error) => {
          this.isLoadingSearch = false;
          console.error(error);
        });
    },
    
    // Reset the shortage form values
    resetShortageForm() {
      this.reason = '';
      this.reasonitem = {
        value: '',
        text: '',
      };
      
    },
    
    //to get Shortage reason
    getBagShortageReason() {
      this.reasonlist = []
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getBagShortageReasonMaster",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var BagShoratgeReasonData = result.data.ResponseData
            for (var i = 0; i < BagShoratgeReasonData.length; i++) {
              this.reasonlist.push({
                value: BagShoratgeReasonData[i].bagshortagereasonmasterid,
                text: BagShoratgeReasonData[i].bagshortagereason
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    //reset search filter's field
    resetflt() {
      this.connectiontype = ''
      this.connectionname = ''
      this.connectionfltlist = []
      this.ConnectionNameData = []
      this.BagShortageData = []
      this.BagDetails = []
      this.BagData = []
      this.opened = []
      this.connectionfltitem = {
        value: '',
        text: '',
        destinationhubid: ''
      }
      this.bagno = ''
      this.isConnectionError = 0
      this.ConnectionError = ''
      this.IsBagDetailsTable = false
      this.IsOverageShipmentBagTable = true
      this.$validator.reset()
      this.showHideCodeIconInput();
    },
    //used in filter form
    onSubmitflt: function(flt) {
      this.$validator.validateAll('flt').then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    //for missing paper bag
    openMissingPaperBagModal() {
      this.IsMissingPaperBag = true
      this.getPaperBagListForMarkMissing();
    },
    closeMissingPaperBagModal() {
      this.IsMissingPaperBag = false
    },
    getPaperBagListForMarkMissing(type) {
      this.missingpaperbaglist = []
      this.disablescanInBtn = false
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + "getPaperBagsDetailsByCSMID?hubId=" + this.hubid + "&connectionScheduleMasterId=" + this.CSMID + '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var paperBagList = result.data.ResponseData
            for (var i = 0; i < paperBagList.length; i++) {
              this.missingpaperbaglist.push({
                text: paperBagList[i].paperbagno
              })
            }
            this.disablescanInBtn = true
          } else if (result.data.ResultCode == 101) {
            if (type !== 'MarkedMissing') {
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.disablePaperWorkBtn = true
            this.disableField = false
          } else {
            this.missingpaperbaglist = []
            if (type !== 'MarkedMissing') {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }
        }, error => {
          console.error(error)
        })
    },
    checkMissingPaperBag() {
      if (this.missingpaperbag == '') {
        this.MissingPaperBagError = "The Paper Bag field is required."
      } else {
        this.MissingPaperBagError = ''
      }
    },
    checkMissingReason() {
      if (this.missingreason == '') {
        this.MissingReasonError = "The Reason field is required."
      } else {
        this.MissingReasonError = ''
      }
    },
    markPaperBagMissing() {
      if (this.missingpaperbag == '') {
        this.MissingPaperBagError = "The Paper Bag field is required."
        return false;
      } else if (this.missingreason == '') {
        this.MissingReasonError = "The Reason field is required."
        return false;
      } else {
        this.MissingPaperBagError = ''
        this.MissingReasonError = ''
        this.disablescanInBtn = false
        this.input = ({
          "PaperBag": this.missingpaperbag,
          "CurrentHubId": this.hubid,
          "CurrentHubName": this.hubName,
          "Reason": this.missingreason,
          "CreatedBy": this.createdby,
          "MissingType": this.missingreason == "Missing" ? true : false,
          "connectionScheduleMasterId": this.CSMID,
          "isManualEntry": this.manualInput,
          "isConnectionRestricted":this.isConnectionRestricted,
          "isHubRestricted" :this.isHubRestricted


        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + "markPaperBagMissing",
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage)
              this.missingpaperbag = ''
              this.missingpaperbagitem = {
                text: ''
              }
              this.MissingPaperBagError = ''
              this.missingreason = ''
              this.MissingReasonError = ''
              this.manualInput = false
              this.getPaperBagListForMarkMissing('MarkedMissing')
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.paperWorkComplete = result.data.paperWorkComplete
            this.pendingCount = result.data.pendingCount
            if (this.paperWorkComplete == true) {
              this.disablePaperWorkBtn = true
              this.disableField = false
            } else {
              this.disablescanInBtn = true
              this.disablePaperWorkBtn = false
              this.disableField = true
            }
          }, error => {
            console.error(error)
          })
      }
    },
    selectedMissingPaperBag(missingpaperbagitem) {
      this.missingpaperbagitem = missingpaperbagitem
      this.missingpaperbag = missingpaperbagitem.text
    },
    MarkMisRouteBag() {
      this.isexceptional = true
    },
    resetMissingPaperBagField() {
      this.missingpaperbag = ''
      this.missingpaperbaglist = []
      this.missingpaperbagitem = {
        text: ''
      }
      this.MissingPaperBagError = ''
      this.missingreason = ''
      this.MissingReasonError = ''
      // this.missroutemsg = ''
      this.IsMissingPaperBag = false
    },


    //for paper Work
    getPendingWorkBagList() {
      if (this.routetype == 'network-local') {
        var routetype = 4
      } else {
        var routetype = 0
      }
      this.showPendingList = true
      window.scrollTo(0, 1000);
      this.parentBagDetails = []
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getPendingPaperNoByHubId?hubid=" + this.hubid + "&connectionType=" + routetype,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.parentBagDetails = result.data.ResponseData
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getPendingMPSList(data, ind) {
      this.childBagDetails = true
      const index = this.viewdata.indexOf(ind);
      if (index > -1) {
        this.viewdata.splice(index, 1)
      } else {
        this.viewdata = [];
        this.viewdata.push(ind)
      }
      this.input = ({
        "paperNo": data.paperno
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getParentMPSDetailsByPaperNo",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.childBagDetails = result.data.ResponseData.ShipmentDetails
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    closePendingMPSList() {
      this.viewdata = [];
    },
    closePendingWorkBagList() {
      this.showPendingList = false
    },


    getPendingPaperBagCount() {
      if(!this.CSMID){
        this.$alertify.error("Inscan vehicle seal first.")
        return false;
      }
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPendingPaperBagCountForInScan?connectionScheduleMasterId=' + this.CSMID + '&hubId=' + this.hubid,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.PendingPaperBagsCount = result.data.PendingPaperBagsCount
          } else if (result.data.ResultCode == 101) {
            this.PendingPaperBagsCount = result.data.PendingPaperBagsCount
          } else {
            this.PendingPaperBagsCount = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },

    getGeneratedPaperBagNoDetails() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
        return false;
      } else {
        this.PaperBagNoError = ''
        this.generatedPaperBagDetails = []
        this.input = ({
          "paperBagNo": this.paperbagno.trim()
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'getPaperWorkDetailsByPaperBagNoForscanIn', //'getPaperWorkDetailsByPaperBagNo',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.generatedPaperBagDetails = result.data.ResponseData
              this.$alertify.success(result.data.ReturnMessage)
              this.getPendingPaperBagCount()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    openPaperWorkBagCard() {
      this.IsPaperWorkBag = true
      this.getPendingPaperBagCount();
      this.getPaperBagCount();
    },
    closePaperWorkBagCard() {
      this.IsPaperWorkBag = false
      this.resetBag()
      this.resetMissingPaperBagField()
    },
    scanPaperWorkBag(IsAWB) {
      this.sector = {};
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
        return false;
      } else {
        this.PaperBagNoError = ''
      }
      if (IsAWB == 1 && this.parentAWB == '') {
        this.ParentAWBError = 'The Parent AWB field is required.'
        return false;
      } else {
        this.ParentAWBError = ''
      }
      if (this.isexceptional == true && this.exceptionreason == '') {
        this.ExceptionError = 'Select Exception Reason'
        return false;
      } else {
        this.ExceptionError = ''
      }
      // if (IsAWB == 1) {
      var str = this.parentAWB.toLowerCase()
      if (str.startsWith("pls")) {
        this.paperbagno = str
      }
      // }
      if (this.parentAWB != "") {
        var AWBNo = this.parentAWB
      } else {
        var AWBNo = this.paperbagno
      }

      this.input = ({
        "paperBag": this.paperbagno,
        "paperBagNo": AWBNo,
        //"paperBagNo": this.paperbagno,
        "hubId": this.hubid,
        "currentHubName": this.hubName,
        "lastModifiedBy": this.createdby,
        "isException": this.isexceptional,
        "expReason": this.exceptionreason,
        "connectionScheduleMasterId": this.vehicletypeitem.value,
        "missingType": this.missingType,
        "isManualEntry":this.manualInscan,
        "isConnectionRestricted":this.isConnectionRestricted,
        "isHubRestricted" :this.isHubRestricted

      })
      if (this.routetype == "network-local") {
        this.input.connectionScheduleMasterId = this.networklocalvehicleitem.value
      }
      if (IsAWB == 1) {
        this.input.paperBagNo = this.parentAWB
      }
      this.disablescanInBtn = false
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'paperLessWorkScanIn',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.missroutemsg = ''
            this.missingType = false
            this.isexceptional = false
            this.$alertify.success(result.data.ReturnMessage)
            if( result.data.sectorDetails){
              this.sector = result.data.sectorDetails;
            }
            if (IsAWB == 1) {
              this.parentAWB = ''
              this.ParentAWBError = ''
            }
            this.manualInscan=false
          } else if (result.data.ResultCode == 401) {
            this.missroutemsg = ''
            this.missingType = false
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 105) {
            this.missroutemsg = result.data.ReturnMessage
            this.isexceptional = true
            this.missingType = true
          } else {
            this.missroutemsg = ''
            this.isexceptional = false
            this.invalidTokenModal = false
            this.missingType = false
            this.$alertify.error(result.data.ReturnMessage)
            if (IsAWB == 1) {
              this.IsParentAWB = false
            } else {
              this.IsParentAWB = true
            }
          }
          this.paperWorkComplete = result.data.paperWorkComplete
          this.pendingCount = result.data.pendingCount
          this.IsParentAWB = result.data.NoAWBScanRequired
          if (this.paperWorkComplete == true) {
            this.disablePaperWorkBtn = true
            this.disableField = false
            this.IsParentAWB=true
          } else {
            if (this.pendingCount>0) {
              this.IsParentAWB = false
            }
            this.disablescanInBtn = true
            this.disablePaperWorkBtn = false
            this.disableField = true
          }
        }, error => {
          console.error(error)
        })
    },
    resetBag() {
      this.paperbagno = ''
      this.parentAWB = ''
      this.PaperBagNoError = ''
      this.isexceptional = false
      this.exceptionreason = ''
      this.ExceptionError = ''
      this.ParentAWBError = ''
      this.PendingPaperBagsCount = ''
      this.missroutemsg = ''
      this.generatedPaperBagDetails = []
      this.missingType = false
      this.IsParentAWB = true
      this.manualInscan = false,
      this.Ispendingpaperwork =false
      this.sector = {};
      this.ShortageBagNo = ''
    },
    checkPaperBagNo() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
      } else {
        this.PaperBagNoError = ''
      }
    },
    checkParentAWB() {
      if (this.parentAWB == '') {
        this.ParentAWBError = 'The Parent AWB field is required.'
      } else {
        this.ParentAWBError = ''
      }
    },

    getPendingInscanBagCount() {
      this.loadingPaperbag = true;
      this.inScannedMPSCount = 0;
      this.inscanPendingMPSCount = 0;
      this.shortageMPSCount = 0;
    
      let apiString = '';
    
      // Construct API string based on route type
      if (this.routetype === 'external') {
        apiString = `getLspInScanPendingCount?lspTripmasterId=${this.lsptripreferenceno}&currentHubId=${this.hubid}`;
      } else {
        apiString = `getInScanPendingCount?ConnectionScheduleMasterId=${this.CSMID}&CurrentHubId=${this.hubid}`;
      }
    
    
      axios({
        method: 'GET',
        url: `${apiUrl.api_url_hubops}${apiString}`,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': "WEB",
          'token': this.token
        }
      })
      .then(({ data }) => {
        if (data.ResultCode === 100) {
          this.invalidTokenModal = false;
          this.InScannedBagsCount = data.InScannedBagsCount;
          this.PendingBagsCount = data.InscanPendingBagsCount;
          console.log("PendingBagsCount "+ this.PendingBagsCount);
          this.ShortageBagsCount = data.ShortageBagsCount;
        } else if (data.ResultCode === 401) {
          this.invalidTokenModal = true;
          this.invalidtokenmsg = data.ReturnMessage;
          this.$alertify.error(data.ReturnMessage);
        } else {
          this.invalidTokenModal = false;
        }
      })
      .catch(error => {
        console.error("Error fetching Pending Inscan Bag Count:", error);
      })
      .finally(() => {
        this.loadingPaperbag = false;
      });
    }
    ,
   
   

    openPaperBagList(IsButtonType,type) {
      if (IsButtonType == 'Pending') {
        this.IsButtonType='Pending';
        this.getPendingPaperBagList(type);
      } else if (IsButtonType == 'InScanned') {
        this.IsButtonType='InScanned';
        this.getInScannedPaperBagList(type);
      } else if(IsButtonType == 'Shortage') {
        this.IsButtonType='Shortage';
        this.getShortagePaperBagList(type);
      }
    },

    openAWBBagList(IsButtonType) {
        this.getPendencyListInscan(IsButtonType);
    },
    closeawblist(){
      this.showawblist=false;
    },

    openmpsList(IsButtonType) {
        this.getMPSList(IsButtonType);
    },
    closeMPSList(){
      this.showmpslist=false;
    },

    getPaperBagCount() {
      if(!this.CSMID){
        this.$alertify.error("Inscan vehicle seal first.")
        return false;
      }
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPaperBagCount?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=inbound'+ '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.getPendingCount=result.data.ResultData.PendingCount;
            this.getInScannedCount=result.data.ResultData.InscanCount;
            this.getMissingCount=result.data.ResultData.MissingCount;
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },

    getInScanPendingCount() {
      this.loadingPaperbag = true;
      this.inScannedMPSCount = 0;
      this.inscanPendingMPSCount = 0;
      this.shortageMPSCount = 0;
    
      let apiString = '';
    
      // Construct API string based on route type
      if (this.routetype === 'external') {
        apiString = `getLspInScanPendingCount?lspTripmasterId=${this.lsptripreferenceno}&currentHubId=${this.hubid}`;
      } else {
        apiString = `getInScanPendingCount?ConnectionScheduleMasterId=${this.CSMID}&CurrentHubId=${this.hubid}`;
      }
    
      // Make the API request
      axios({
        method: 'GET',
        url: `${apiUrl.api_url_hubops}${apiString}`,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token
        }
      })
      .then(({ data }) => {
        if (data.ResultCode === 100) {
          // Update the counts with the response data
          this.InScannedBagsCount = data.InScannedBagsCount;
          this.PendingBagsCount = data.InscanPendingBagsCount;
          this.ShortageBagsCount = data.ShortageBagsCount;
          // this.inscanPendingBagsCount = data.InscanPendingBagsCount;
          // this.inScannedBagsCount = data.InScannedBagsCount;
          // this.shortageBagsCount = data.ShortageBagsCount;
          this.inScannedMPSCount = data.InScannedMPSCount;
          this.inscanPendingMPSCount = data.InscanPendingMPSCount;
          this.shortageMPSCount = data.ShortageMPSCount;
        } else {
          this.$alertify.error(data.ReturnMessage);
        }
        this.loadingPaperbag = false;
      })
      .catch(error => {
        console.error(error);
        this.loadingPaperbag = false;
      });
    },
    
    completeInbound () {
        const input = {
          "ConnectionScheduleMasterId": this.CSMID,
          "CurrentHubId": Number(this.hubid),
          "LastModifiedBy" : this.createdby,
          "tripid": Number(this.vehicletripid)
        };

        axios({
          method: 'POST',
          url: `${apiUrl.api_url_hubops}completeInbound`,
          data: input, 
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },

    getPendingPaperBagList(type) {
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPendingPaperBags?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=inbound'+ '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.paperBagData = result.data.ResponseData;
             (type== 'paperwork' && this.getPendingCount)? this.Ispendingpaperwork=true: this.Ispendingpaperbag=true;
            this.$alertify.success(result.data.ReturnMessage)
          }else {
            this.Ispendingpaperbag=false;
            this.Ispendingpaperwork=false;
            this.paperBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },

    getInScannedPaperBagList(type) {
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getInScannedPaperBags?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=inbound',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.paperBagData = result.data.ResponseData;
            (type && this.getInScannedCount)? this.Ispendingpaperwork=true: this.Ispendingpaperbag=true;
            this.$alertify.success(result.data.ReturnMessage)
          }  else {
            this.Ispendingpaperbag=false;
            this.Ispendingpaperwork=false;
            this.paperBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },

    getShortagePaperBagList(type) {
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getMissingPaperBags?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=inbound',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.paperBagData = result.data.ResponseData;
            (type && this.getMissingCount)? this.Ispendingpaperwork=true: this.Ispendingpaperbag=true;
            this.$alertify.success(result.data.ReturnMessage)
          }  else {
            this.Ispendingpaperbag=false;
            this.Ispendingpaperwork=false;
            this.paperBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },

    getPendencyListInscan(IsButtonType){
      this.IsButtonType=IsButtonType;
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPendencyListInscan?ConnectionScheduleMasterId=' + this.CSMID + '&CurrentHubId=' + this.hubid + '&Status=' +IsButtonType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.awbPendencyList = result.data.ResponseData;
            this.showawblist=true;
            this.$alertify.success(result.data.ReturnMessage)
          }  else {
            this.awbPendencyList=[]
            this.showawblist=false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },

    getMPSList(IsButtonType){
      this.IsButtonType=IsButtonType;
      this.loadingPaperbag=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getMPSList?ConnectionScheduleMasterId=' + this.CSMID + '&CurrentHubId=' + this.hubid + '&Status=' +IsButtonType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.mpsList = result.data.ResponseData;
            this.showmpslist=true;
            this.$alertify.success(result.data.ReturnMessage)
          }  else {
            this.mpsList=[]
            this.showmpslist=false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.loadingPaperbag=false;
        }, error => {
          console.error(error);
          this.loadingPaperbag=false;
        })
    },


    closePendingPaperBagList(){
      this.Ispendingpaperbag=false;
    },


    openPendingInscanList(IsButtonType, type) {
      window.scrollTo(0, 500);
      this.IsPendingInscanList = true
      if (IsButtonType == 'Pending') {
        this.bagstatus = 'Pending'
        this.PendingInscanBagData = [];
        this.isShoratge = false
      } else if (IsButtonType == 'InScanned') {
        this.bagstatus = 'InScanned'
        this.PendingInscanBagData = [];
        this.isShoratge = false
      } 
       else {
        this.isShoratge = false
        this.bagstatus = ''
      }
      if (IsButtonType == 'Pending' && type == 'MarkShortage') {
        this.bagstatus = 'Pending'
        this.listtype = this.activeTab === 'B2B' ? 'Cargo' : 'Ecom'
        this.isShoratge = true
        this.IsPendingInscanList = false
      }
      if (this.listtype != '') {
        this.getPendingInscanBagCount();
        this.getPendingInscanBagList();
      }
    },
    getPendingInscanBagList() {
      const url = (this.routetype === 'external')
      ? `${apiUrl.api_url_hubops}getLspPendencyListInscan?lspTripmasterId=${this.lsptripreferenceno}&currentHubId=${this.hubid}&status=${this.bagstatus}`
      : `${apiUrl.api_url_hubops}getInScanAndPendingList`;
     
     
    const method = this.routetype === 'external' ? 'GET' : 'POST';
  
    // Prepare input data for the POST request (if not external)
    const input = this.routeType !== 'external' ? {
      "ConnectionScheduleMasterId": this.CSMID,
      "CurrentHubId": this.hubid,
      "Status": this.bagstatus,
      "ListType": this.listtype
    } : null;
      axios({
        method,
        url,
        data: input, 
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PendingInscanBagData = result.data.ResponseData;
            this.getPendingInscanBagCount();
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PendingInscanBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },


    displayShortageBagList() {
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getShortageBagsList?ConnectionScheduleMasterId=' + this.CSMID + "&CurrentHubId=" + this.hubid,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.ShortageBagRecord = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.ShortageBagRecord = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },

    displayLspShortageBagList() {
        this.IsPendingInscanList = true;
        this.bagstatus = 'Shortage'
        this.PendingInscanBagData = [];
        this.isShoratge = false;
        this.getPendingInscanBagCount();
        this.getPendingInscanBagList();
      
      
    },

    //For Close Vehicle
    hideCloseVehicleModal() {
      this.closeVehicleModal = false
      this.IsAllowToCloseVehicle = false
      this.CloseVehicleMsg = ''
    },
    closeVehicle(type) {
      if (type == 'Yes') {
        this.IsAllowToCloseVehicle = true
      } else {
        this.IsAllowToCloseVehicle = false
      }
      if (type == 'loadbag') {
        if (this.routetype == 'network') {
          this.input = ({
            "ConnectionScheduleMasterID": this.vehicletypeitem.value,
            "IsClose": false,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": false
          })
        } else {
          this.input = ({
            "ConnectionScheduleMasterID": this.networklocalvehicleitem.value,
            "IsClose": false,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.networklocalarrivalsealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": false
          })
        }
      } else {
        if (this.routetype == 'network') {
          this.input = ({
            "ConnectionScheduleMasterID": this.vehicletypeitem.value,
            "IsClose": true,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": this.IsAllowToCloseVehicle
          })
        } else {
          this.input = ({
            "ConnectionScheduleMasterID": this.networklocalvehicleitem.value,
            "IsClose": true,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.networklocalarrivalsealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": this.IsAllowToCloseVehicle
          })
        }
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'closeVehicle',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.closeVehicleModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.resetForm();
          } else if (result.data.ResultCode == 105) {
            this.closeVehicleModal = false
            this.$alertify.success(result.data.ReturnMessage)
            if (type == 'loadbag') {
              this.$router.push('/NetworkManagement')
            }
          } else if (result.data.ResultCode == 109) {
            this.CloseVehicleMsg = result.data.ReturnMessage
            this.closeVehicleModal = true
          } else {
            this.closeVehicleModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },

    redirectLspVehicleForLoad(type) {
      if (type == 'Yes') {
        this.IsAllowToCloseVehicle = true
      } else {
        this.IsAllowToCloseVehicle = false
      }
      if (type == 'loadbag') {
            this.closeVehicleModal = false
            this.$router.push('/NetworkManagement')  
    }
  },


    getCargoParentMPSDetails(data) {
      this.CargoParentMPSDetails = [];
      this.CargoParentMPSDataModel = true
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getCargoParentMPSDetails?ParentMPS=' + data.ParentMPS + '&ShipmentStatus=' + data.Status,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CargoParentMPSDetails = result.data.ResponseData;
          } else {
            this.CargoParentMPSDetails = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },
    closeCargoParentMPSDataModel() {
      this.CargoParentMPSDataModel = false
    },
    //for prealert data
    openPrealertmodal() {
      this.Prealertmodal = true
    },
    closePrealertmodal() {
      this.Prealertmodal = false
      this.resetModalField()
    },
    resetModalField() {
      this.selectedRow = ''
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.Isreasonerror = ''
      this.reasonError = ''
      this.selectedRowError = ''
    },
    getPrealertTripData(IsReloadList) {
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getDestinationPrealert?hubid=' + this.hubid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertTripData = result.data.ResponseData;
            if (IsReloadList == 1) {
              this.$alertify.success(result.data.ReturnMessage)
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertTripData = [];
            if (IsReloadList == 1) {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }
        }, error => {
          console.error(error);
        })
    },
    getPrealertBagData(data, ind) {
      this.PrealertPrintmodal = true
      this.PrintData = data
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'generateBagDetailInvoice?connectionschedulemasterid=' + data.connectionschedulemasterid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertBagData = result.data.ResponseData;
            this.prealertConnection = result.data.ResponseData[0].connectionname
            this.prealertVehicle = result.data.ResponseData[0].vehicleno
            this.prealertInvoiceDate = result.data.ResponseData[0].invoicedate
            this.prealertInvoiceTime = result.data.ResponseData[0].invoicetime
            var shipment = []
            var phywt = []
            var volwt = []
            for (var i = 0; i < this.PrealertBagData.length; i++) {
              shipment.push(Number(this.PrealertBagData[i].bagshipmentscnt))
              phywt.push(Number(this.PrealertBagData[i].physicalweight))
              volwt.push(Number(this.PrealertBagData[i].volumetricweight))
            }
            this.totalshipment = shipment.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.totalphysicalwt = phywt.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.totalvolumetricwt = volwt.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },
    closePrealertPrintmodal() {
      this.PrealertPrintmodal = false
    },
    getPrealertBagShortageData(data, index) {
      this.Prealertmodal = true
      this.PrealertBagShortageList = []
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getBagDetailsForPrealert?connectionschedulemasterid=' + data.connectionschedulemasterid + '&destinationhubid=' + this.hubid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertBagShortageList = result.data.ResponseData;
            // this.$alertify.success(result.data.ReturnMessage)
            this.getBagShortageReason()
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertBagShortageList = [];
            // this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },
    selectBag() {
      if (this.selectedRow == '') {
        this.selectedRowError = 'Select Bag Number'
      } else {
        this.selectedRowError = ''
      }
    },
    download() {
      const doc = new jsPDF('p', 'pt', 'a2');
      const contentHtml = document.getElementById('printData');
      doc.fromHTML(contentHtml, 15, 15, {
        width: 170,
      });
      doc.save("prealert.pdf");
    },
    //Print Unloading Sheet
    openUnloadingSheetModel() {
      this.UnloadingSheetModel = true
      this.IsUnloadingSheet = true
    },
    closeUnloadingSheetModel() {
      this.UnloadingSheetModel = false
      this.unloadingtripsheetno = ''
      this.TripSheetNoError = ''
      this.IsSheet = false
      this.isLoadingSheetModal = false
    },
    cancelUnloadingSheetField() {
      this.unloadingtripsheetno = ''
      this.TripSheetNoError = ''
      this.UnloadingTripData = []
      this.UnloadingBagData = []
      this.IsSheet = false
      this.isLoadingSheetModal = false
    },
    getUnloadingTripSheetDetails() {
      if (this.unloadingtripsheetno == '') {
        this.TripSheetNoError = 'The Trip Sheet No field is required.'
        return false;
      } else {
        this.TripSheetNoError = ''
        this.UnloadingTripData = []
        this.UnloadingBagData = []
        this.isLoadingSheetModal = true
        axios({
            'method': 'GET',
            'url': apiUrl.api_url_hubops + 'getPaperBagsWithAWBDetailsByTripNo?tripSheetNo=' + this.unloadingtripsheetno.trim() + '&currentHubId=' + this.hubid,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoadingSheetModal = false
            if (result.data.ResultCode == 100) {
              this.UnloadingTripData = result.data.TripDetails;
              this.UnloadingBagData = result.data.BagDetails;
              this.IsSheet = true
              this.$alertify.success(result.data.ReturnMessage)
            } else {
              this.UnloadingTripData = [];
              this.UnloadingBagData = [];
              this.IsSheet = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingSheetModal = false
            console.error(error);
          })
      }
    },
    getBag(string) {
      let reg = /.{1,6}/
      return string.replace(reg, (m) => "*".repeat(m.length))
    },
    gettotalMPSCount(row) {
      var totalMPSCount = 0;
      for (var i = 0; i < row.length; i++) {
        totalMPSCount = totalMPSCount + parseFloat(row[i].mpscount)
      }
      return totalMPSCount;
    },
    gettotalWeight(row) {
      var totalWeight = 0;
      for (var i = 0; i < row.length; i++) {
        totalWeight = totalWeight + parseFloat(row[i].parentawbweight)
      }
      return totalWeight;
    },
    printSheet() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('tripsheetContent'), cssText);
    },
    /*nxb and xb changes*/
    validatebuttons(){
    let result = false
    if((this.updatedVehicleSealNo || this.pVehicleSealNo) && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
      for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
        if (this.updatedVehicleSealNo.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase()) ||
        this.pVehicleSealNo.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
            result = true;
            break;
          }
        }
      }
      return result;
  },
  validateforDepartureSealNo(){
    let result = false
    if(this.networklocaldeparturesealno && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
      for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
        if (this.networklocaldeparturesealno.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
            result = true;
            break;
          }
        }
      }
    return result;
  },

  markBagShortagevisibility(data) {
    this.loadingPaperbag=true;
      this.input = ({
        "currentHubId": this.hubid,
        "currentHubName": this.hubName,
        "parentBagNo": data.bagno,
        "lastModifiedBy": this.createdby,
        "reason": "",
        "centerType": this.centerType,
        "statusMarkedFrom": "WEB"
      })
    axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'markBagShortage',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': "WEB",
          'token': this.token
        }
      })
      .then(result => {
        this.loadingPaperbag=false;
        if (result.data.ResultCode == 100) {
          this.$alertify.success(result.data.ReturnMessage)
          if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
          this.getPendingInscanBagCount();
        } else {
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => {
        console.error(error)
        this.loadingPaperbag=false;
      })
  },

  async loadShipmentDetails(shippingid) {
    try {
      const result = await axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getShipmentDetailsForShortage?flow=markShortage&ShippingID=' + shippingid,
        headers: {
          'Authorization': 'authkey xB84JJ89Hd25'
        }
      });

      const response = result.data;

      if (response.ResultCode === 100 && response.ResponseData) {
        return response.ResponseData;
      } else {
        this.$alertify.error(result.data.ReturnMessage);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },


  markMPSShortage(data) {
    this.loadingPaperbag=true;
      this.input = ({
        "processLocation": this.hubid,
        "shippingId": data.shippingid,
        "lastModifiedBy": this.createdby,
        "centerType": this.centerType,
        "shipmentStatus":data.shipmentstatus ? data.shipmentstatus:'',
        "status":data.status,
        "isManualEntry":this.manualInput,
        "shipmentCurrentHub": this.hubid,
        "userId":this.userid,
        "TripID":Number(this.vehicletripid)
      })

    axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'markShipmentShortage',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': "WEB",
          'token': this.token
        }
      })
      .then(result => {
        this.loadingPaperbag=false;
        if (result.data.ResultCode == 100) {
          this.$alertify.success(result.data.ReturnMessage)
          if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
          this.getPendingInscanBagCount();
          
          this.getPendingB2BandB2CList();
        } else {
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => {
        console.error(error)
        this.loadingPaperbag=false;
      })
  },
  canMarkAWBPaperworkShortage(data) {
    if (!data || !data.parentmpsstatus) {
      return true;
    }
    const status = String(data.parentmpsstatus).toLowerCase();
    return status !== 'inscan' && status !== 'inscanned';
  },
  confirmAWBPaperworkShortage(data) {
    if (!this.canMarkAWBPaperworkShortage(data)) {
      return;
    }
    this.AWBPaperworkShortageData = data;
    this.ConfirmAWBPaperworkShortage = true;
  },
  closeAWBPaperworkShortageConfirm() {
    this.ConfirmAWBPaperworkShortage = false;
    this.AWBPaperworkShortageData = null;
  },
  markAWBPaperworkShortage() {
    if (!this.AWBPaperworkShortageData) {
      return;
    }
    const data = this.AWBPaperworkShortageData;
    this.loadingPaperbag = true;
    this.input = ({
      "paperBag": data.parentbagno || this.paperbagno,
      "paperBagNo": data.paperno,
      "hubId": this.hubid,
      "currentHubName": this.hubName,
      "lastModifiedBy": this.createdby,
      "isException": this.isexceptional,
      "expReason": this.exceptionreason,
      "connectionScheduleMasterId": this.vehicletypeitem.value,
      "missingType": this.missingType,
      "isManualEntry": this.manualInscan,
      "isConnectionRestricted": this.isConnectionRestricted,
      "isHubRestricted": this.isHubRestricted,
      "markShortage": true,
      "statusMarkedFrom": "WEB"
    })
    if (this.routetype == "network-local") {
      this.input.connectionScheduleMasterId = this.networklocalvehicleitem.value
    }
    axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'paperLessWorkScanIn',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': "WEB",
          'token': this.token
        }
      })
      .then(result => {
        this.loadingPaperbag = false;
        if (result.data.ResultCode == 100) {
          this.$alertify.success(result.data.ReturnMessage)
          if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
          this.closeAWBPaperworkShortageConfirm();
          this.getGeneratedPaperBagNoDetails();
          this.getPaperBagCount();
          this.getPendingInscanBagCount();
        } else {
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => {
        console.error(error)
        this.$alertify.error("API Error")
        this.loadingPaperbag = false;
      })
  },

  refreshtripsummary(){
    this.getInScanPendingCount();
    this.getPaperBagCount();
  },

  /* No Bags For Loading Functionality  start*/

  scanOutPaperBag() {
       this.showOutScanTab = true
       this.isLoading = true;
       this.input = ({
         "PaperBagNo": this.finalpaperbagno,
         "ConnectionScheduleMasterID": this.CSMID,
         "UserHubID": this.hubid,
         "UserHubName": this.hubName,
         "LastModifiedBy": this.createdby,
         "isManualEntry": this.manualInput,
         "isConnectionRestricted":this.isConnectionRestricted,
         "isHubRestricted" :this.isHubRestricted
       })
       axios({
           method: 'POST',
           url: apiUrl.api_url_hubops + 'paperLessWorkScanOut',
           data: this.input,
           headers: {
             'authorization': 'authkey xB84JJ89Hd25'
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
             this.$alertify.success(result.data.ReturnMessage)
             this.manualInput = false;
           } else {
             this.$alertify.error(result.data.ReturnMessage)
           }
           this.getPaperBagCount();
           this.getPaperBagCountOutscan();
           this.isLoading = false;
         }, error => {
           this.isLoading = false;
           console.error(error)
         })
   },


  resetPaperBag() {
      this.finalpaperbagno = ''
    },

   cancelAllocation(e) {
     this.pVehicleSealNo = '';
     this.CurrentKM = '';
     this.finalpaperbagno  = '';
     this.showcnfrmAllocation = false;
     this.vehicleSealNoTab = false;
     this.showOutScanTab = false;
     this.disablenobagforloadingbtn = true;
     this.showScanOut = true;
     this.AllowDepartureSeal = true;
     this.vehicledepartureSealCondition();
     const field = document.getElementById("networklocaldeparturesealno");
     if (field) field.disabled = false;
     this.$validator.reset();
     e.preventDefault();
   },

   vehicledepartureSealCondition(){
     if(this.isDestination == true){
       this.AllowDepartureSeal = false;
     }else{
       this.AllowDepartureSeal = true;
     }
   },

   confirmAllocation() {
     if(this.pVehicleSealNo != ''){
       let sealno = this.validatebuttons()
       if(!sealno){
         this.$alertify.error('Vehicle Seal Number Must Start With '+ this.vehiclesealdata.sealprefix.join(" or "));
         return false
       }
     }
       this.isLoading = true;
       this.input = ({
         "ConnectionScheduleMasterID": this.CSMID,
         "CurrentHubId": this.hubid,
         "CurrentHubName": this.hubName,
         "VehicleSealNo": this.pVehicleSealNo,
         "currentKm": this.CurrentKM,
         "LastModifiedBy":this.createdby,
         "isConnectionRestricted":this.isConnectionRestricted,
         "isHubRestricted":this.isHubRestricted
       })
     axios({
         method: 'POST',
         url: apiUrl.api_url_hubops + 'tripConfirmAllocation',
         data: this.input,
         headers: {
           'authorization': 'authkey xB84JJ89Hd25',
           'requestfrom': "WEB",
           'token': this.token
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alertify.success(result.data.ReturnMessage)
           if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
           this.resetPageAfterConfirmation();
         }
         else
           {
           this.$alertify.error(result.data.ReturnMessage)         }
         user_tracker.checkUserIP(this.userData[0], "tripConfirmConnection", this.$route.path,this.input)
         this.isLoading = false;
       }, error => {
         this.isLoading = false;
         console.error(error)
       })
   },

   resetPageAfterConfirmation(){
     this.routetype= '';
     this.localvehicle = '';
     this.currentkm = '';
     this.networklocalvehicle = '';
     this.networklocalsealstatus = '';
     this.networklocalsealcondition = '';
     this.networklocalarrivalsealno = '';
     this.vehicletype = '';
     this.networklocalclosekm = '';
     this.checkSealCondition = '';
     this.vehiclesealno = '';
     this.invalidsealreason = '';
     this.finalpaperbagno  = '';
     this.showcnfrmAllocation = false;
     this.vehicleSealNoTab = false;
     this.showOutScanTab = false;
     this.disablenobagforloadingbtn = true;
     this.InvalidReason = false;
     this.AllowDepartureSeal = false;
     this.disableFieldforDeparture = false;
     this.paperBagCount =false ;
     this.IsPendingInscanBtn = false;
     const field = document.getElementById("networklocaldeparturesealno");
      if (field) field.disabled = false;
   },
   /* get paper bag pending and outscanned count from API */
    getPaperBagCountOutscan() {
      this.Loading = true;
      this.disablenobagforloadingbtn = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPaperBagCount?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=outbound'+ '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted ,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.getPendingCountOutscan = result.data.ResultData.PendingCount;
            if(this.isDestination == true){
             this.getPendingCountOutscan = -1
             this.AllowDepartureSeal = false
            }
            this.OutScanCount = result.data.ResultData.OutScanCount;

          } else{
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.Loading = false;
        }, error => {
          this.Loading = false;
          console.error(error);
        })
    },
      /* get paper bag outscanned details of that paper bag from API */
    getOutscanPaperBagDetailsOutScan() {
      this.CountDetails = [];
      this.Loading = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getOutScannedPaperBags?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=outbound',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CountDetails = result.data.ResponseData;
            this.PaperBagPendingOutscanListModel = true;
          } else{
            this.PaperBagPendingOutscanListModel = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.Loading = false;
        }, error => {
          this.Loading = false;
          console.error(error);
        })
    },
    /* get paper bag Pending details of that paper bag from API */
    getPendingPaperBagDetailsOutScan() {
      this.CountDetails = [];
      this.Loading = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPendingPaperBags?csmid=' + this.CSMID + '&currenthubid=' + this.hubid + '&type=outbound'+ '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CountDetails = result.data.ResponseData;
              this.PaperBagPendingOutscanListModel = true;
          } else{
            this.PaperBagPendingOutscanListModel = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.Loading = false;
        }, error => {
          this.Loading = false;
          console.error(error);
        })
    },

    closePaperBagPendingOutscanListModel() {
      this.PaperBagPendingOutscanListModel = false;
    },

    flagConditionChecking(){
        this.showcnfrmAllocation =false;
        this.disablenobagforloadingbtn = false;
        this.AllowDepartureSeal = false;
        const pendingBags = this.PendingBagsCount ? this.PendingBagsCount : 0;
        const pendingMps = this.inscanPendingMPSCount ? this.inscanPendingMPSCount: 0;
        if (this.isCompleteInboundFeatureEnabled && (pendingBags > 0 || pendingMps > 0)) {
           this.disablenobagforloadingbtn = true;
            if (this.routetype == "network" && this.vehicletypeitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
            if (this.routetype == "network-local" && this.networklocalvehicleitem.isdestination == false) {
              this.AllowDepartureSeal = true
            }
           this.$alertify.error("Complete Inbound action pending! Please scan all bags/MPS or mark shortages to continue");
           return false;
        }
        if(!this.isHubRestricted){
        this.vehicleSealNoTab = this.showcnfrmAllocation = true;
      }else{
          this.showOutScanTab = this.vehicleSealNoTab =this.showcnfrmAllocation = true;
          this.getPaperBagCountOutscan();
        }
    },

    onSubmitSealNo: function(Tab) {
      this.$validator.validateAll('Tab').then((result) => {
        if (result) {
          this.confirmAllocation();
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    onSubmitPaperBag: function(PaperBagTab) {
      this.$validator.validateAll('PaperBagTab').then((result) => {
        if (result) {
            this.scanOutPaperBag();
        }else{
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    openPendingB2BandB2C() {
      window.scrollTo(0, 500);
      this.showPendingB2BandB2CList = true;
      this.activeTab = 'B2C';
      this.getPendingB2BandB2CList();
    },

    getPendingB2BandB2CList() {
      this.pendingEcommShortageDetails = [];
      this.pendingMPSShortageDetails = [];
      this.isLoadingSearch = true;

      const input = {
          "ConnectionScheduleMasterId": this.CSMID,
          "CurrentHubId": Number(this.hubid),
          "LastModifiedBy" : this.createdby
        };
      axios({
        method: 'POST',
      url: `${apiUrl.api_url_hubops}getPendingBagsMPSList`,
          data: input, 
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
            .then(({ data }) => {
              this.isLoadingSearch = false;
        if (data.ResultCode === 100) {
        this.pendingEcommShortageDetails = data.ResponseData.PendingBags,
          this.pendingMPSShortageDetails = data.ResponseData.PendingMPS,
          this.$alertify.success(data.ReturnMessage)
        }else {
        this.$alertify.error(data.ReturnMessage)
        }
      })
      .catch(error => {
        console.error(error);
        this.isLoadingSearch = false;
      })
      .finally(() => {
        this.loadingPaperbag = false;
      })
    },
     intiateAllPendingBagShortage() {
      this.intiateAllBagShortage = true;
		},
		intiateCloseConfirmation() {
			this.intiateAllBagShortage = false;
		},

     initateShortageRequest() {
      this.isLoadingSearch = true;
      const input = {
          "tripid": Number(this.vehicletripid),
          "hubid": Number(this.hubid),
          "createdby" : this.createdby,
          "userId" :Number(this.userid)
        };
      axios({
          method: 'POST',
          url: `${apiUrl.api_url_hubops}insertUserShortageRequest`,
          data: input, 
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
        })
      .then(({ data }) => {
        if (data.ResultCode === 100) {
          this.isLoadingSearch = false;
          this.$alertify.success(data.ReturnMessage)
          if (data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: data.nudgeMessage, duration: data.nudgeDuration }) }
          this.intiateAllBagShortage = false;
        }else {
          this.isLoadingSearch = false;
          this.$alertify.error(data.ReturnMessage)
                    this.intiateAllBagShortage = false;
        }
      })
      .catch(error => {
        console.error(error);
        this.isLoadingSearch = false;
      })
      .finally(() => {
        this.loadingPaperbag = false;
      });
    },
getIsDockMandatory(){
  this.dockLoading = true;
     axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/isDockMandatory?hubId=' + this.hubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        if (result.data.ResultCode == 100) {
         this.isDockMandatory = result.data.ResponseData.is_mandatory
         if(this.isDockMandatory){
          this.getDockList();
         } else {
          this.dockLoading = false;
         }
        }
        else{
          this.dockLoading = false;
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error);
        this.dockLoading = false;
       });

  },

  
  getDockList() {
      this.dockList = [];
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockList?hubId=' + this.hubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        this.dockLoading = false;
        if (result.data.ResultCode == 100) {
          result.data.ResponseData.forEach(item => {
            this.dockList.push({ value: item.dock_barcode, text: item.dock_id });
          });
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error); 
        this.dockLoading = false;
      });
    },
      getDockChangeReason() {
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockReasons?type=dock_change_reasons',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        console.log("result",result)
        if (result.data.ResultCode == 100) {
          this.getDockChangeReasonList = result.data.ResponseData.map(r => ({ value: r.id, text: r.reason }));
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error); });
    },

    selectDock(selectedData) {
      this.selectedDock = selectedData;
      this.dockId = selectedData.text;
      this.dockbarcode = selectedData.value;
      this.scannedDockBarcode = selectedData.value;
      this.dockIdError = false;

    // For local/linehaul — fetch vehicles from dock
      if (this.routetype === 'local' || this.routetype === 'linehaul') {
        this.showDockVehicleDropdown = true;
        this.getDockVehicles();
      } else {
        this.showDockVehicleDropdown = false;
      }

    },

    onDockBarcodeScan() {
      const value = this.scannedDockBarcode ? String(this.scannedDockBarcode).trim() : '';
      if (!value) {
        this.dockbarcode = '';
        this.dockId = '';
        this.selectedDock = { value: '', text: '' };
        this.showDockVehicleDropdown = false;
        this.dockVehiclesList = [];
        this.selectedDockVehicle = { value: '', text: '' };
        this.lastFetchedDockBarcode = '';
        return;
      }
      // Case-insensitive local lookup so casing / trailing-whitespace differences from the scanner do not break the mapping.
      const normalized = value.toLowerCase();
      const match = this.dockList.find(d => String(d.value).trim().toLowerCase() === normalized);
      if (match) {
        this.dockbarcode = match.value;
        this.dockId = match.text;
        this.selectedDock = { value: match.value, text: match.text };
        this.scannedDockBarcode = match.value;
        this.dockIdError = false;
        if (this.routetype === 'local' || this.routetype === 'linehaul') {
          this.showDockVehicleDropdown = true;
          this.getDockVehicles();
        } else {
          this.showDockVehicleDropdown = false;
        }
        return;
      }
      // Fallback: dockList may be stale or missing entries; resolve barcode -> dock_id via backend.
      this.dockbarcode = value;
      this.dockId = '';
      this.selectedDock = { value: '', text: '' };
      this.dockIdError = false;
      this.validateBarcode(value, 'primary').then(({ valid }) => {
        // Gate on `valid` (barcode resolves to a real dock at this hub),
        // NOT `ok` — for local/linehaul a full-capacity dock is still
        // scannable and the operator needs to see the vehicles already
        // parked there so they can pick which one to work on. Only
        // genuinely invalid / errored barcodes short-circuit.
        if (!valid) return;
        if (this.routetype === 'local' || this.routetype === 'linehaul') {
          this.showDockVehicleDropdown = true;
          this.getDockVehicles();
        } else {
          this.showDockVehicleDropdown = false;
        }
      });
    },

    focusScanDockInput() {
      this.$nextTick(() => {
        if (this.$refs.scanDockInput && typeof this.$refs.scanDockInput.focus === 'function') {
          this.$refs.scanDockInput.focus();
        }
      });
    },

    focusNewDockScanInput() {
      this.$nextTick(() => {
        if (this.$refs.scanNewDockInput && typeof this.$refs.scanNewDockInput.focus === 'function') {
          this.$refs.scanNewDockInput.focus();
        }
      });
    },

    onNewDockBarcodeScan() {
      const value = this.newScannedDockBarcode ? String(this.newScannedDockBarcode).trim() : '';
      if (!value) {
        this.newDockBarcode = '';
        this.newDockId = '';
        this.newDockSelected = { value: '', text: '' };
        return;
      }
      const normalized = value.toLowerCase();
      const match = this.dockList.find(d => String(d.value).trim().toLowerCase() === normalized);
      if (match) {
        this.newDockBarcode = match.value;
        this.newDockId = match.text;
        this.newDockSelected = { value: match.value, text: match.text };
        this.newScannedDockBarcode = match.value;
        this.newDockIdError = false;
        return;
      }
      this.newDockBarcode = value;
      this.newDockId = '';
      this.newDockSelected = { value: '', text: '' };
      this.newDockIdError = false;
    },

    selectDockVehicle(selectedData) {
     this.selectedDockVehicle = selectedData;
    },


    getDockVehicles() {
    if (!this.dockbarcode) return;

    const targetDockBarcode = this.dockbarcode;

    if (this.lastFetchedDockBarcode !== targetDockBarcode) {
      this.dockVehiclesList = [];
      this.selectedDockVehicle = { value: '', text: '' };
    }
    this.dockVehicleLoading = true;
    let tripType = this.routetype || 'local';
    axios({
      method: 'GET',
      url: apiUrl.api_url_hubops + 'dockmaster/getDockVehicles?dock_barcode=' + targetDockBarcode + '&hub_id=' + this.hubid + '&trip_type=' + this.routetype,
      headers: { 'authorization': 'authkey xB84JJ89Hd25' }
    }).then(result => {
      this.dockVehicleLoading = false;
      this.lastFetchedDockBarcode = targetDockBarcode;
      if (result.data.ResultCode == 100) {
        const vehicles = result.data.ResponseData.vehicles || [];
        const allowNew = result.data.ResponseData.allow_new_vehicle === true;
        this.dockVehiclesList = vehicles.map(v => ({
          value: v.session_id,
          text: v.vehicle_number,
          tripId: v.trip_id,
          operationType: v.operation_type
        }));
        // Multi-slot dock (max_vehicles > 1) with capacity remaining: offer a
        // sentinel row so the operator can dock in a second vehicle. Selecting
        // it sends an empty vehicle_number to `POST /dockmaster/dockIn`; the
        // BE either reuses the existing dummy for local/linehaul (idempotent)
        // or creates a fresh session — see the __NEW__ handling below.
        if (allowNew && vehicles.length > 0) {
          this.dockVehiclesList.push({
            value: '__NEW__',
            text: 'New Vehicle',
            tripId: '',
            operationType: ''
          });
        }
        this.showDockVehicleDropdown = this.dockVehiclesList.length > 0;
      } else {
        this.showDockVehicleDropdown = false;
        this.$alertify.error(result.data.ReturnMessage);
      }
    }, error => {
      this.dockVehicleLoading = false;
      console.error(error);
    });
  },      

    checkDockIn(vehicleNumber) {
      if (!vehicleNumber) {
        // HUB: never leave the dock loader stuck if we bail out before firing the request
        this.dockLoading = false;
        return;
      }
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/checkDockIn?hubId=' + this.hubid + '&vehicleNumber=' + vehicleNumber,
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      }).then(result => {
        // HUB: clear loader here too so the dock section renders even if getDockList() hangs or errors
        this.dockLoading = false;
        if (result.data.ResultCode == 100 && result.data.ResponseData.is_docked_in) {
          this.dockbarcode = result.data.ResponseData.dock_barcode;
          this.dockId = result.data.ResponseData.dock_id;
          this.selectedDock = { value: result.data.ResponseData.dock_barcode, text: result.data.ResponseData.dock_id };
          // HUB: retain the auto-loaded scanned barcode in the input when returning to the page after dock-in
          this.scannedDockBarcode = result.data.ResponseData.dock_barcode;
          this.isDockIn = true;
          this.$alertify.success("Already Dock-In at " + result.data.ResponseData.dock_barcode);
        }
      }, error => {
        this.dockLoading = false;
        console.error(error);
      });
    },

    performDockOut() {
      const vehicleNumber = (this.scanInRes && this.scanInRes.vehicleNumber)
        ? String(this.scanInRes.vehicleNumber).trim()
        : '';
      if (!vehicleNumber) {
        this.$alertify.error('Vehicle number is missing for dock-out.');
        return;
      }
      const payload = {
        hub_id: Number(this.hubid),
        vehicle_number: vehicleNumber,
        dock_out_by: this.createdby,
        is_manual: false,
        status_marked_from: 'WEB',
      };
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/dockOut',
        data: payload,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token,
        },
      }).then(result => {
        const data = result && result.data ? result.data : {};
        if (data.ResultCode === 100) {
          this.$alertify.success(data.ReturnMessage || 'Dock-out recorded successfully.');
          this.disableDockOutButton = true;
          // Vehicle has left the dock — clear dock-in state so the bag-seal
          // input re-disables (isDockMandatory && !isDockIn) and the operator
          // is prompted to dock-in again before the next bag inscan. This is
          // the sole dock-in gate (there is no server-side scanIn check), so
          // dock-in → inscan → dock-out → inscan will demand a fresh dock-in.
          this.isDockIn = false;
          this.resetDock();
        } else if (data.ResultCode === 101) {
          this.$alertify.success(data.ReturnMessage || 'No active dock session for this vehicle.');
          this.disableDockOutButton = true;
          // No active session for this vehicle — treat as docked-out and
          // reset dock-in state so the operator must dock-in before inscan.
          this.isDockIn = false;
          this.resetDock();
        } else if (data.ResultCode === 401 || data.ResultCode === 500) {
          this.invalidTokenModal = true;
          this.invalidtokenmsg = data.ReturnMessage || 'Session expired, please log in again.';
        } else {
          this.$alertify.error(data.ReturnMessage || 'Dock-out failed.');
        }
      }, error => {
        console.error(error);
        const status = error && error.response ? error.response.status : null;
        if (status === 401 || status === 500) {
          this.invalidTokenModal = true;
          this.invalidtokenmsg = 'Session expired, please log in again.';
        } else {
          this.$alertify.error('Dock-out request failed.');
        }
      });
    },

    validateBarcode(barcode, target /* 'primary' | 'new' */) {
      return new Promise((resolve) => {
        if (!barcode) { resolve({ ok: false, reason: 'empty' }); return; }
        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'dockmaster/validateBarcode',
          data: {
            dock_barcode: String(barcode).trim(),
            hub_id: Number(this.hubid),
          },
          headers: { 'authorization': 'authkey xB84JJ89Hd25' }
        }).then(result => {
          const data = (result && result.data) || {};
          const resp = data.ResponseData || {};
          if (data.ResultCode == 100 && resp.dock_id) {
            // Barcode is a real dock at this hub → always populate the
            // target vars so scan-time UX resolves the dock name AND
            // (for local/linehaul) can fetch the vehicle list even when
            // capacity is full. Capacity is a click-time concern signalled
            // via `ok: false, reason: 'full'` so click-time callers keep
            // aborting the same way they did before this refactor.
            if (target === 'primary') {
              this.dockbarcode = barcode;
              this.dockId = resp.dock_id;
              this.selectedDock = { value: barcode, text: resp.dock_id };
              this.scannedDockBarcode = barcode;
              this.dockIdError = false;
            } else {
              this.newDockBarcode = barcode;
              this.newDockId = resp.dock_id;
              this.newDockSelected = { value: barcode, text: resp.dock_id };
              this.newScannedDockBarcode = barcode;
              this.newDockIdError = false;
            }
            if (resp.is_available === false) {
              this.$alertify.error(data.ReturnMessage || 'Dock is at full capacity.');
              resolve({ ok: false, valid: true, reason: 'full', dock_id: resp.dock_id });
              return;
            }
            resolve({ ok: true, valid: true, dock_id: resp.dock_id });
          } else {
            this.$alertify.error(data.ReturnMessage || 'Invalid dock barcode.');
            resolve({ ok: false, valid: false, reason: 'invalid' });
          }
        }, err => {
          console.error(err);
          this.$alertify.error('Dock barcode validation failed.');
          resolve({ ok: false, valid: false, reason: 'error' });
        });
      });
    },

       async dockIn() {
        if (!this.dockbarcode) {
          this.dockIdError = true;
          return;
        }

        const { ok: isValid } = await this.validateBarcode(this.dockbarcode, 'primary');
        if (!isValid) return;

        let vehicleNumber = '';
        let tripId = '';
        let csmid = '';
        if(!this.routetype){
          this.routetype ='local'
        }
        if (this.routetype === 'local' || this.routetype === 'linehaul') {
          if (this.dockVehiclesList.length > 0 && !this.selectedDockVehicle.text) {
            this.$alertify.error('Please select a vehicle');
            return;
          }
          // `__NEW__` sentinel = "dock in a new vehicle at this multi-slot dock".
          // BE generates the dummy from (dock_barcode, hub_id, trip_type) so we
          // must send an empty vehicle_number here; sending the sentinel text
          // literally would poison dock_sessions with "New Vehicle".
          if (this.selectedDockVehicle.value === '__NEW__') {
            vehicleNumber = '';
            tripId = '';
          } else {
            vehicleNumber = this.selectedDockVehicle.text;
            tripId = this.selectedDockVehicle.tripId || '';
          }
          csmid = '';
        } else if (this.routetype === 'network-local') {
          vehicleNumber = this.networklocalvehicleitem.vehicleno || '';
          tripId = this.networklocalvehicleitem.tripid ? this.networklocalvehicleitem.tripid.toString() : '';
          csmid = this.networklocalvehicleitem.value ? this.networklocalvehicleitem.value.toString() : '';
        } else {
          // network or other
          vehicleNumber = this.vehicletypeitem.vehicleno || '';
          tripId = this.vehicletypeitem.tripid ? this.vehicletypeitem.tripid.toString() : '';
          csmid = this.vehicletypeitem.value ? this.vehicletypeitem.value.toString() : '';
        }
        this.input = {
          dock_barcode: this.dockbarcode,
          hub_id: this.hubid,
          vehicle_number: vehicleNumber,
          // csmid: csmid,
          trip_type: this.routetype,
          operation_type: "Midmile_Inbound",
          trip_id: tripId,
          dock_in_by: this.createdby,
          override_reason: ""
        };

        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'dockmaster/dockIn',
          data: this.input,
          headers: { 'authorization': 'authkey xB84JJ89Hd25' }
        }).then(result => {
          if (result.data.ResultCode == 100) {
            this.isDockIn = true;

            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => { this.$alertify.error('Dock-In API Error'); });
      },

      openChangeDockModal() {
      this.getDockChangeReason();
      this.getDockList();
      this.showChangeDockModal = true;
      this.newDockId = '';
      this.newDockBarcode = '';
      this.newDockSelected = { value: '', text: '' };
      this.newScannedDockBarcode = '';
      this.changeDockReason = '';
      this.selectedDockChangeReason = { value: '', text: '' };
      this.selectedDockChangeReasonError = '';
      this.newDockIdError = false;
      this.changeDockReasonError = false;
    },


    closeChangeDockModal() {
      this.showChangeDockModal = false;
    },

    selectNewDock(selectedData) {
      this.newDockSelected = selectedData;
      this.newDockId = selectedData.text;
      this.newDockBarcode = selectedData.value;
      this.newScannedDockBarcode = selectedData.value;
      this.newDockIdError = false;
    },
    selectReasonForNewDock(selectedData) {
      this.selectedDockChangeReason = selectedData;
      console.log("selected",this.selectedReason)
      this.selectedDockChangeReasonError = false;
    },
    
    async saveDockChange() {
      // Validate all required fields
      let isValid = true;

      if (!this.newDockBarcode || this.newDockBarcode === '') {
        this.newDockIdError = true;
        isValid = false;
      }

      if (!this.selectedDockChangeReason || !this.selectedDockChangeReason.value) {
        this.selectedDockChangeReasonError = true;
        isValid = false;
      }

      if (!isValid) return;

      const { ok: isDockValid } = await this.validateBarcode(this.newDockBarcode, 'new');
      if (!isDockValid) return;
      
        let vehicleNumber = '';
        let tripId = '';
        let csmid = '';

        if (this.routetype === 'local' || this.routetype === 'linehaul') {
          // Must select vehicle from dock dropdown
          vehicleNumber = this.selectedDockVehicle.text;

          
        } else if (this.routetype === 'network-local') {
          vehicleNumber = this.networklocalvehicleitem.vehicleno || '';
          
        } else {
          // network or other
          vehicleNumber = this.vehicletypeitem.vehicleno || '';
          
        }



      this.input = {
        vehicle_number: vehicleNumber,
        new_dock_barcode: this.newDockBarcode,
        hub_id: this.hubid,
        modifiedBy: this.createdby,
        reason:this.selectedDockChangeReason.text,
        status_marked_from: 'WEB'

      };

      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/changeDock',
        data: this.input,
        headers: { 'authorization': 'authkey xB84JJ89Hd25'}
      }).then(result => {
        if (result.data.ResultCode == 100) {
          this.dockId = this.newDockId;
          this.dockbarcode = this.newDockBarcode
          this.scannedDockBarcode = this.newDockBarcode;
          this.selectedDock = { value: this.newDockBarcode, text: this.newDockId };
          this.showChangeDockModal = false;
          this.$alertify.success(result.data.ReturnMessage);
          this.resetChangeDockForm();
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => { this.$alertify.error('Change Dock API Error'); });
    },

 resetChangeDockForm() {
  this.newDockId = '';
  this.newDockBarcode = '';
  this.newDockBarcode = '';
  this.newDockSelected = { value: '', text: '' };
  this.newScannedDockBarcode = '';
  this.newScannedDockBarcode = '';
  this.selectedDockChangeReason = { value: '', text: '' };
  this.selectedDockChangeReasonError = '';
  this.changeDockReason = '';
  this.newDockIdError = false;
  this.changeDockReasonError = false;
  if (this.showChangeDockModal) this.focusNewDockScanInput();
},


  resetDock() {
    this.selectedDock = { value: '', text: '' };
    this.dockId = '';
    this.dockbarcode = '';
    this.scannedDockBarcode = '';
    this.dockIdError = false;
    this.showDockVehicleDropdown = false;
    this.lastFetchedDockBarcode = '';
    // this.dockVehiclesList = [];
    // this.selectedDockVehicle = { value: '', text: '' };
    if (this.isDockMandatory) this.focusScanDockInput();
  },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/CenterScanInTrip/CenterScanInTrip.js